(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5401],{

/***/ 91973:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SW": () => (/* reexport */ API_BASE_URL_HTTP),
  "qf": () => (/* reexport */ API_ROUTES),
  "XO": () => (/* reexport */ API_ROUTE_PREFIX),
  "j6": () => (/* reexport */ API_ROUTE_PREFIX_HTTPS),
  "UO": () => (/* reexport */ API_ROUTE_V2_PREFIX_HTTPS),
  "Sb": () => (/* reexport */ API_TIMEOUT_IN_MS),
  "JQ": () => (/* reexport */ interceptors)
});

// UNUSED EXPORTS: API_BASE_URL_HTTP_COMMONS_CB, API_ROUTE_PREFIX_COMMONS_CB, API_ROUTE_V2_PREFIX, CMS_API_BASE_URL, SEO_PAGES_QUERY_ID, SEO_PAGES_V2_QUERY_ID

;// CONCATENATED MODULE: ../../libs/api-utils/src/apiConstants/index.ts
/* provided dependency */ var process = __webpack_require__(34406);
const API_BASE_URL_HTTP = process.env["API_BASE_URL_HTTP"];
const API_BASE_URL_HTTP_COMMONS_CB = process.env["ENV"] === "prod" ? `http://mapi.mmt.mmt` : `http://mapi.makemytrip.com`;
const API_ROUTE_PREFIX = "/ext/api/v1/partners";
const API_ROUTE_V2_PREFIX = "/ext/api/v2/partners";
const API_ROUTE_PREFIX_HTTPS = "/insurance/ext/api/v1/partners";
const API_ROUTE_V2_PREFIX_HTTPS = "/insurance/ext/api/v2/partners";
const API_ROUTE_PREFIX_COMMONS_CB = "/commons-cb/api/v1/mmt";
const API_TIMEOUT_IN_MS = 10000;
let API_ROUTES;

(function (API_ROUTES) {
  API_ROUTES["GET_ORDERS_RETAIL_MYPARTNER"] = "mmt/insurance/mypartner/cb/orders";
  API_ROUTES["HIT_RETAIL_CONSENT"] = "mmt/insurance/mypartner/cb/registerConsent";
  API_ROUTES["GET_LANDING_PAGE_DETAILS_MY_PARTNER"] = "mmt/insurance/mypartner/cb/landing";
  API_ROUTES["GET_NEXT_PAGE_ROUTE_MYPARTNER"] = "mmt/insurance/mypartner/cb/nextPageData";
  API_ROUTES["GET_LANDING_PAGE_DETAILS"] = "insurance/cb/landing";
  API_ROUTES["GET_PRODUCT_LISTING"] = "insurance/cb/quotes";
  API_ROUTES["GET_TRAVEL_ATTRIBUTES"] = "insurance/cb/travelattributes";
  API_ROUTES["PAYMENT_CHECKOUT"] = "insurance/cb/checkout";
  API_ROUTES["GET_PASSPORT_DETAILS"] = "insurance/cb/passportDetails";
  API_ROUTES["EDIT_INSURANCE_DETAILS"] = "insurance/cb/endorsement";
  API_ROUTES["ORDER_CONFIRMED"] = "insurance/cb/thankyou";
  API_ROUTES["ORDER_LISTING"] = "insurance/cb/orders";
  API_ROUTES["ORDER_DETAIL"] = "insurance/cb/orderDetail";
  API_ROUTES["TRIGGER_EMAIL"] = "insurance/cb/email";
  API_ROUTES["GET_NEXT_PAGE_ROUTE"] = "insurance/cb/nextPageData";
  API_ROUTES["CHECK_CHECKOUT_ELIGIBILITY"] = "insurance/cb/login/eligibility";
  API_ROUTES["GET_COMMON_LANDING_PAGE_DETAILS"] = "insurance/cb/common-landing";
  API_ROUTES["GET_ENTRYPOINT_LANDING_PAGE_DATA"] = "insurance/cb/entrypoint";
  API_ROUTES["GET_GENERIC_PATH"] = "insurance/cb";
  API_ROUTES["GET_SUGGESTIONS_INFO"] = "insurance/cb/employees/autosuggest";
  API_ROUTES["GET_COMMONS_HEADER_DATA"] = "desktop/header";
  API_ROUTES["DOWNLOAD_TEMPLATE"] = "insurance/cb/files/download";
  API_ROUTES["UPLOAD_TEMPLATE"] = "insurance/cb/excel-upload";
})(API_ROUTES || (API_ROUTES = {}));

const CMS_API_BASE_URL = process.env["CMS_API_BASE_URL"] || "http://tripmoney-insurance.mmt.com";
const SEO_PAGES_QUERY_ID = {
  LANDING_PAGE_DEFAULT: "seo-insurance-landing-default",
  LANDING_PAGE_COUNTRY: "seo-insurance-landing-country-default",
  LANDING_PAGE_DEFAULT_GI: "seo-insurance-gi-landing-default",
  LANDING_PAGE_COUNTRY_GI: "seo-insurance-gi-landing-country-default"
};
const SEO_PAGES_V2_QUERY_ID = {
  LANDING_PAGE_COUNTRY: "seo-insurance-landing-v2-country-default",
  LANDING_PAGE_COUNTRY_GI: "seo-insurance-gi-landing-v2-country-default"
};
;// CONCATENATED MODULE: ../../libs/api-utils/src/apiTypes/index.ts

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ../../libs/api-utils/src/interceptors/enhanceRequestHeaders.ts
/* provided dependency */ var enhanceRequestHeaders_process = __webpack_require__(34406);


const _excluded = ["cookie", "mobile-device", "cmp", "dvid", "device-id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getHost(headers) {
  let goibiboHost = enhanceRequestHeaders_process.env["MOCK_HOST"] || headers?.["x-goibibo-host"];

  if (goibiboHost && goibiboHost.includes("goibibo")) {
    goibiboHost = "www.goibibo.com";
  }

  return goibiboHost || headers?.["x-forwarded-host"] || headers?.["host"];
}

function enhanceRequestHeaders(headers) {
  const _ref = headers || {},
        {
    cookie = "",
    "mobile-device": mobile_device,
    cmp,
    dvid,
    "device-id": device_id
  } = _ref,
        restHeaders = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  let x_tm_device = mobile_device === "true" ? "mobile" : "desktop";
  let goMmtHost = getHost(headers);

  if (typeof navigator !== "undefined") {
    x_tm_device = /Mobile|Android|BlackBerry/.test(navigator.userAgent) ? "mobile" : "desktop";
  }

  if (typeof cmp === "string" && cmp != "") {
    return _objectSpread({
      cmp,
      cookie,
      "x-tm-device": x_tm_device,
      "X-Tm-Client": "desktop",
      "device-id": dvid || device_id || "",
      "Content-Type": "application/json"
    }, headers?.["x-ins-gommt-host"] || goMmtHost ? {
      "x-ins-gommt-host": headers?.["x-ins-gommt-host"] || goMmtHost
    } : {});
  }

  return _objectSpread({
    cookie,
    "x-tm-device": x_tm_device,
    "X-Tm-Client": "desktop",
    "device-id": dvid || device_id || "",
    "Content-Type": "application/json"
  }, headers?.["x-ins-gommt-host"] || goMmtHost ? {
    "x-ins-gommt-host": headers?.["x-ins-gommt-host"] || goMmtHost
  } : {});
}
;// CONCATENATED MODULE: ../../libs/api-utils/src/interceptors/retryAxiosRequest.ts
const retryAxiosRequest = (error, axios) => {
  const {
    config,
    response
  } = error;
  const {
    url
  } = config;
  console.error(["API RESPONSE ERROR:", JSON.stringify({
    url,
    status: response?.status,
    responseData: response?.data,
    responseHeaders: response?.headers,
    requestBody: config?.data,
    requestHeaders: config?.headers
  })].join(" | "));

  if (response?.status && response.status < 400 || !config || !config.retry) {
    return Promise.reject(error);
  } //decrease retry count by 1


  config.retry -= 1; // Return Promise to retry the request

  return axios.request(config);
};
;// CONCATENATED MODULE: ../../libs/api-utils/src/interceptors/types.ts

;// CONCATENATED MODULE: ../../libs/api-utils/src/interceptors/index.ts


const interceptors = {
  enhanceRequestHeaders: enhanceRequestHeaders,
  retryAxiosRequest: retryAxiosRequest
};


;// CONCATENATED MODULE: ../../libs/api-utils/src/index.ts





/***/ }),

/***/ 44928:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AUTO_SUGGESTION_PAGE_SIZE": () => (/* reexport */ AUTO_SUGGESTION_PAGE_SIZE),
  "COLLEAGUES_TITLE": () => (/* reexport */ COLLEAGUES_TITLE),
  "CONTEXT": () => (/* reexport */ CONTEXT),
  "DATE_FORMATS": () => (/* reexport */ DATE_FORMATS),
  "ERROR_CODES": () => (/* reexport */ ERROR_CODES),
  "FORM_FIELDS_MAP": () => (/* reexport */ FORM_FIELDS_MAP),
  "GENDER_VALUES": () => (/* reexport */ GENDER_VALUES),
  "LOB": () => (/* reexport */ LOB),
  "LONG_WEEK_DAYS": () => (/* reexport */ LONG_WEEK_DAYS),
  "MONTHS": () => (/* reexport */ MONTHS),
  "PARTNER": () => (/* reexport */ PARTNER),
  "PARTNER_DOMAIN_NAME": () => (/* reexport */ PARTNER_DOMAIN_NAME),
  "PASSPORT_DETAILS_PAGE_ID": () => (/* reexport */ PASSPORT_DETAILS_PAGE_ID),
  "PLATFORM": () => (/* reexport */ PLATFORM),
  "RESPONSE_STATUS": () => (/* reexport */ RESPONSE_STATUS),
  "STORAGE_KEYS": () => (/* reexport */ STORAGE_KEYS),
  "TRAVELLER_NUMBER_CONSTANTS": () => (/* reexport */ TRAVELLER_NUMBER_CONSTANTS),
  "TXN_SUCCESS_REDIRECT_TIME": () => (/* reexport */ TXN_SUCCESS_REDIRECT_TIME),
  "constants": () => (/* reexport */ constants),
  "deviceType": () => (/* reexport */ deviceType),
  "isOnServer": () => (/* reexport */ isOnServer)
});

// UNUSED EXPORTS: MONTHS_SHORT, PRE_SALES_PAGES, SHORT_WEEK_DAYS, TRIPMONEY_DOMAIN_NAME, TXN_FAILURE_REDIRECT_TIME, UTM_PARAMS, breakpoint

;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/constants.ts
let RESPONSE_STATUS;

(function (RESPONSE_STATUS) {
  RESPONSE_STATUS["SUCCESS"] = "SUCCESS";
  RESPONSE_STATUS["ERROR"] = "ERROR";
})(RESPONSE_STATUS || (RESPONSE_STATUS = {}));

let CONTEXT;

(function (CONTEXT) {
  CONTEXT["INSURANCE"] = "insurance";
  CONTEXT["STANDALONE"] = "standalone";
  CONTEXT["STANDALONE_V2"] = "standalone_v2";
})(CONTEXT || (CONTEXT = {}));

let PLATFORM;

(function (PLATFORM) {
  PLATFORM["WEB"] = "web";
})(PLATFORM || (PLATFORM = {}));

let LOB;

(function (LOB) {
  LOB["STANDALONE"] = "standalone";
  LOB["STANDALONE_MYBIZ"] = "standalone_mybiz";
  LOB["MYPARTNER"] = "standalone_mypartner";
})(LOB || (LOB = {}));

let ERROR_CODES;

(function (ERROR_CODES) {
  ERROR_CODES["DISPLAY_ERROR"] = "DISPLAY_ERROR";
})(ERROR_CODES || (ERROR_CODES = {}));

let UTM_PARAMS;

(function (UTM_PARAMS) {
  UTM_PARAMS["UTM_SOURCE"] = "utm_source";
  UTM_PARAMS["UTM_MEDIUM"] = "utm_medium";
  UTM_PARAMS["UTM_CAMPAIGN"] = "utm_campaign";
  UTM_PARAMS["UTM_INS_CAMPAIGN"] = "utm_ins_campaign";
})(UTM_PARAMS || (UTM_PARAMS = {}));

let STORAGE_KEYS;

(function (STORAGE_KEYS) {
  STORAGE_KEYS["TRAVELLER_DETAILS"] = "traveller-details";
})(STORAGE_KEYS || (STORAGE_KEYS = {}));

const FORM_FIELDS_MAP = Object.freeze({
  name: "name",
  dob: "date of birth",
  gender: "gender",
  mobile: "mobile number",
  email: "email id",
  passport: "passport number",
  gstNumber: "GST number",
  companyDetails: "company details",
  nomineeName: "nominee name"
});
const GENDER_VALUES = [{
  id: "1",
  label: "Male",
  isSelected: false
}, {
  id: "2",
  label: "Female",
  isSelected: false
}, {
  id: "3",
  label: "Others",
  isSelected: false
}];
const AUTO_SUGGESTION_PAGE_SIZE = 20;
const COLLEAGUES_TITLE = "YOUR COLLEAGUES";
const TXN_SUCCESS_REDIRECT_TIME = 5000;
const TXN_FAILURE_REDIRECT_TIME = 5000;
let PASSPORT_DETAILS_PAGE_ID;

(function (PASSPORT_DETAILS_PAGE_ID) {
  PASSPORT_DETAILS_PAGE_ID["PAYMENT_SUCCESS"] = "PAYMENT_SUCCESS";
  PASSPORT_DETAILS_PAGE_ID["ORDER_CONFIRMED"] = "ORDER_CONFIRMED";
})(PASSPORT_DETAILS_PAGE_ID || (PASSPORT_DETAILS_PAGE_ID = {}));

const TRAVELLER_NUMBER_CONSTANTS = {
  MAX_TRAVELLERS: 20,
  MIN_TRAVELLERS: 1
};
const constants = {
  formErrorToast: "Please enter the required details to continue",
  addErrorToast: "Please add all traveller details to continue"
};
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/date.ts
let DATE_FORMATS;

(function (DATE_FORMATS) {
  DATE_FORMATS["DDD"] = "ddd";
  DATE_FORMATS["YY"] = "yy";
  DATE_FORMATS["YYYY"] = "yyyy";
  DATE_FORMATS["D MMM"] = "d MMM";
  DATE_FORMATS["DD/MM/YYYY"] = "dd/MM/yyyy";
  DATE_FORMATS["DD MMM YY"] = "dd MMM''yy";
  DATE_FORMATS["dd MMM, yyyy"] = "dd MMM, yyyy";
  DATE_FORMATS["YYYY-MM-DD"] = "yyyy-MM-dd";
  DATE_FORMATS["DD MMM YYYY"] = "dd MMM yyyy";
  DATE_FORMATS["DD-MMM-YYYY"] = "dd MMM, yyyy";
})(DATE_FORMATS || (DATE_FORMATS = {}));

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
const MONTHS_SHORT = (/* unused pure expression or super */ null && (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
const SHORT_WEEK_DAYS = (/* unused pure expression or super */ null && (["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"]));
const LONG_WEEK_DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/device.ts
// RESPONSIVE BREAKPOINTS
const breakpoint = {
  mobile: 768
};
const deviceType = {
  mobile: `(max-width: ${breakpoint.mobile}px)`,
  desktop: `(min-width: ${breakpoint.mobile}px)`
};
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/domain.ts
const TRIPMONEY_DOMAIN_NAME = {
  MMT: ["tripmoney.makemytrip.com", "insurance.makemytrip.com", "www.makemytrip.com"],
  GI: ["tripmoney.goibibo.com", "insurance.goibibo.com", "www.goibibo.com"],
  TRIPMONEY: ["www.tripmoney.com"],
  MYPARTNER: ["mypartner.makemytrip.com"],
  MYBIZ: ["mybiz.makemytrip.com"]
};
let PARTNER_DOMAIN_NAME;

(function (PARTNER_DOMAIN_NAME) {
  PARTNER_DOMAIN_NAME["MMT"] = ".makemytrip.com";
  PARTNER_DOMAIN_NAME["GI"] = ".goibibo.com";
  PARTNER_DOMAIN_NAME["TRIPMONEY"] = "tripmoney.com";
  PARTNER_DOMAIN_NAME["MYPARTNER"] = "mypartner.makemytrip.com";
  PARTNER_DOMAIN_NAME["MYBIZ"] = "mybiz.makemytrip.com";
})(PARTNER_DOMAIN_NAME || (PARTNER_DOMAIN_NAME = {}));

const PRE_SALES_PAGES = (/* unused pure expression or super */ null && (["landing", "common-landing", "next-page", "listing", "review"]));
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/partner.ts
const PARTNER = {
  MMT: "mmt",
  GI: "gi",
  TRIPMONEY: "tripmoney",
  UNKNOWN: "unknown",
  MYPARTNER: "mypartner",
  MYBIZ: "mybiz"
};
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/index.ts





// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/types.ts
var types = __webpack_require__(20362);
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/isOnServer/index.ts
const isOnServer = () => {
  if (false) {}

  return false;
};
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/index.ts




/***/ }),

/***/ 20362:
/***/ (() => {



/***/ }),

/***/ 2349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tZ": () => (/* reexport */ akamaiGetDevice),
  "mJ": () => (/* reexport */ getLobOnServerSide)
});

// UNUSED EXPORTS: akamaiDCparser, getDeviceType, getHTTPRoutePrefix, getHost, getPartnerOnServerSide, getPathPartnerOnServerSide

;// CONCATENATED MODULE: ../../libs/server-utils/src/akamaiGetDevice/index.ts
function akamaiGetDevice(headers = {}) {
  const isTabletHeader = headers["tablet-device"];
  const isMobileHeader = headers["mobile-device"];
  let device = "desktop";

  switch ("true") {
    case isTabletHeader:
      device = "tablet";
      break;

    case isMobileHeader:
      device = "mobile";
      break;

    default:
      device = "desktop";
  }

  return device;
}
const akamaiDCparser = header => {
  const separator = ";";

  if (!header) {
    return {};
  }

  try {
    const akamaiDCHeader = Object.fromEntries(header.split(separator).map(v => v.split(/=(.*)/).map(decodeURIComponent)));
    return akamaiDCHeader;
  } catch (e) {
    return {};
  }
};
// EXTERNAL MODULE: ../../libs/api-utils/src/index.ts + 6 modules
var src = __webpack_require__(91973);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
;// CONCATENATED MODULE: ../../libs/server-utils/src/getApiRouteDetails/index.ts


const getHTTPRoutePrefix = partner => {
  if (isOnServer()) {
    if (partner === PARTNER.MYBIZ || partner === PARTNER.MYPARTNER) {
      return API_ROUTE_V2_PREFIX;
    }
  }

  return API_ROUTE_PREFIX;
};
const getLobOnServerSide = partner => {
  if ((0,isomorphic_utils_src.isOnServer)()) {
    if (partner === isomorphic_utils_src.PARTNER.MYPARTNER) {
      return isomorphic_utils_src.LOB.MYPARTNER;
    } else if (partner === isomorphic_utils_src.PARTNER.MYBIZ) {
      return isomorphic_utils_src.LOB.STANDALONE_MYBIZ;
    }

    return isomorphic_utils_src.LOB.STANDALONE;
  }

  return isomorphic_utils_src.LOB.STANDALONE;
};
const getPathPartnerOnServerSide = partner => {
  if (partner === PARTNER.MYPARTNER || partner === PARTNER.MYBIZ) {
    return PARTNER.MMT;
  }

  return partner;
};
// EXTERNAL MODULE: ../../node_modules/bowser/es5.js
var es5 = __webpack_require__(77160);
;// CONCATENATED MODULE: ../../libs/server-utils/src/getDeviceType/index.ts


const DeviceDetector = __webpack_require__(9375);

const AKAMAI_DC_KIND = {
  isMobile: "is_mobile",
  isTablet: "is_tablet"
};
const getDeviceType = (userAgent, opts, req) => {
  let pwaApp = true;
  const {
    akamaiDCHeaders,
    isDesktop
  } = opts || {};
  const desktopView = isDesktop || req?.cookies?.["isDesktop"];
  const domain = ".makemytrip.com";
  const akamaiIsMobile = akamaiDCHeaders?.[AKAMAI_DC_KIND.isMobile];

  if (akamaiIsMobile === "true") {
    pwaApp = true;
    return pwaApp;
  }

  if (akamaiIsMobile === "false") {
    pwaApp = false;
    return pwaApp;
  }

  if (userAgent) {
    const browser = bowser.getParser(userAgent);
    const platform = browser.getPlatform().type;

    if (platform === "bot") {
      const deviceDetector = new DeviceDetector();
      const {
        device
      } = deviceDetector.parse(userAgent);
      pwaApp = false;

      if (device && device.type === "smartphone") {
        pwaApp = true;
      }
    } else if (platform === "desktop") {
      pwaApp = false;
    }
  } else {
    pwaApp = false;
  }

  return pwaApp;
};
;// CONCATENATED MODULE: ../../libs/server-utils/src/getHost/index.ts
// for www.goibibo.com
//  apache ALB set's x-goibibo-host as www.goibibo.com
//  which is available on both len-tripmoney-insurance-standalone and pay-len-krysalis service
//  apache ALB doesn't set host header
//  and hence x-forwarded-host is set to len-krysalis.ecs.mmt
// for insurance.goibibo.com, tripmoney.goibibo.com, www.makemytrip.com, insurance.makemytrip.com, tripmoney.makemytrip.com
//  krysalis set's x-forwarded-host as correct host name
//  which is available on len-tripmoney-insurance-standalone service
// Host is always set to len-tripmoney-mono-insurance-standalone.ecs.mmt for all cases
function getHost_getHost(headers) {
  // we can get headers?.["x-goibibo-host"] as 'www.goibibo.com,www.goibibo.com' as well, hence we need to check if it includes goibibo
  // and then set it to www.goibibo.com
  let goibiboHost = headers?.["x-goibibo-host"];

  if (goibiboHost && goibiboHost.includes("goibibo")) {
    goibiboHost = "www.goibibo.com";
  }

  return goibiboHost || headers?.["x-forwarded-host"] || headers?.["host"];
}
;// CONCATENATED MODULE: ../../libs/server-utils/src/getPartnerOnServerSide/index.ts


const getPartnerOnServerSide = headers => {
  if (isOnServer()) {
    const host = getHost(headers);

    if (typeof host === "string") {
      if (TRIPMONEY_DOMAIN_NAME.MYPARTNER.includes(host)) {
        return PARTNER.MYPARTNER;
      } else if (TRIPMONEY_DOMAIN_NAME.MYBIZ.includes(host)) {
        return PARTNER.MYBIZ;
      } else if (TRIPMONEY_DOMAIN_NAME.GI.includes(host)) {
        return PARTNER.GI;
      } else {
        return PARTNER.MMT;
      }
    }
  }

  return PARTNER.MMT;
};
;// CONCATENATED MODULE: ../../libs/server-utils/src/index.ts






/***/ }),

/***/ 69085:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DEVICE_MODEL_TYPE": () => (/* reexport */ DEVICE_MODEL_TYPE),
  "HOST": () => (/* reexport */ HOST)
});

// UNUSED EXPORTS: DEVICE_TYPE

;// CONCATENATED MODULE: ../../libs/types/src/lib/enum/index.ts
let DEVICE_TYPE;

(function (DEVICE_TYPE) {
  DEVICE_TYPE["DESKTOP"] = "desktop";
  DEVICE_TYPE["MOBILE"] = "mobile";
  DEVICE_TYPE["TABLET"] = "tablet";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));

let DEVICE_MODEL_TYPE;

(function (DEVICE_MODEL_TYPE) {
  DEVICE_MODEL_TYPE["APP"] = "App";
  DEVICE_MODEL_TYPE["WEB"] = "Web";
})(DEVICE_MODEL_TYPE || (DEVICE_MODEL_TYPE = {}));

const HOST = {
  TRIPMONEY: "www.tripmoney.com",
  MAKEMYTRIP: "www.makemytrip.com",
  GOIBIBO: "www.goibibo.com",
  LOCALHOST: "localhost",
  TRIPMONEY_MAKEMYTRIP: "tripmoney.makemytrip.com"
};
// EXTERNAL MODULE: ../../libs/types/src/lib/interfaces/index.ts
var interfaces = __webpack_require__(93214);
;// CONCATENATED MODULE: ../../libs/types/src/index.ts



/***/ }),

/***/ 93214:
/***/ (() => {



/***/ }),

/***/ 87109:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mq": () => (/* reexport */ ExperimentTrackingStringContext/* ExperimentTrackingString */.M),
  "IY": () => (/* reexport */ InnerContentWrap),
  "bU": () => (/* reexport */ useBreakpointV2),
  "OM": () => (/* reexport */ withDeviceAndThemeProvider/* withDeviceAndThemeProvider */.O)
});

// UNUSED EXPORTS: usePartnerContext, useReferrerContext

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/ExperimentTrackingStringContext.ts
var ExperimentTrackingStringContext = __webpack_require__(45658);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hoc/withDeviceAndThemeProvider.tsx
var withDeviceAndThemeProvider = __webpack_require__(12390);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/DeviceContext.ts
var Contexts_DeviceContext = __webpack_require__(79138);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useDeviceContext.ts


const useDeviceContext = () => {
  return useContext(DeviceContext);
};
const useDeviceV2 = () => (0,react.useContext)(Contexts_DeviceContext/* DeviceContextV2 */.M);
const useBreakpointV2 = () => {
  const device = useDeviceV2();

  switch (device) {
    case "mobile":
      return "sm";

    case "desktop":
      return "lg";

    case "tablet":
      return "md";

    default:
      return "md";
  }
};
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/CommonStyle/CommonStyles.style.ts


const InnerContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CommonStylesstyle__InnerContentWrap",
  componentId: "sc-1tlkskw-0"
})(["width:1200px;margin:0 auto;@media screen and ", "{width:100%;}"], src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/index.ts






/***/ }),

/***/ 79138:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ DeviceContextV2)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const DeviceContextV2 = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)("mobile");
const DeviceContext = /*#__PURE__*/(/* unused pure expression or super */ null && (createContext(null)));
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (DeviceContext)));

/***/ }),

/***/ 45658:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ ExperimentTrackingString)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const ExperimentTrackingString = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)("");

/***/ }),

/***/ 16965:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ PartnerContext),
/* harmony export */   "L": () => (/* binding */ PartnerContextProvider)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);



const PartnerContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const PartnerContextProvider = ({
  hostname,
  children,
  partnerType
}) => {
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    const element = document.getElementById("pageId");
    element.classList.remove("mmtTheme", "giTheme", "myBizTheme");

    if (partnerType === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MYBIZ) {
      element.classList.add("myBizTheme");
    } else if (partnerType === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT) {
      element.classList.add("mmtTheme");
    } else if (partnerType === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.PARTNER.GI) {
      element.classList.add("giTheme");
    }
  }, [partnerType]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(PartnerContext.Provider, {
    value: partnerType,
    children: children
  });
};

/***/ }),

/***/ 90932:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ReferrerContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const ReferrerContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)("");
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReferrerContext);

/***/ }),

/***/ 12390:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ withDeviceAndThemeProvider)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79138);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);



function withDeviceAndThemeProvider(comp, device, theme) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_1__/* .DeviceContextV2.Provider */ .M.Provider, {
    value: device,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(styled_components__WEBPACK_IMPORTED_MODULE_0__/* .ThemeProvider */ .f6, {
      theme: theme,
      "data-test-id": "ThemeProvider",
      children: comp
    })
  });
}

/***/ }),

/***/ 48619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": () => (/* reexport */ usePartnerContext),
  "u": () => (/* reexport */ useReferrerContext)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/ReferrerContext.ts
var ReferrerContext = __webpack_require__(90932);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useReferrerContext.ts


const useReferrerContext = () => {
  return (0,react.useContext)(ReferrerContext/* default */.Z);
};
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/PartnerContext.tsx
var PartnerContext = __webpack_require__(16965);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/usePartnerContext.ts


const usePartnerContext = () => {
  const context = (0,react.useContext)(PartnerContext/* PartnerContext */.H);

  if (context === null) {
    console.error("usePartnerContext must be used within a PartnerContextProvider");
  }

  return context;
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts



/***/ }),

/***/ 54927:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y6": () => (/* reexport */ TextStyles_AnchorTag),
  "C2": () => (/* reexport */ AnchorTagStyle),
  "YP": () => (/* reexport */ BackDropComp_BackDropComp),
  "Il": () => (/* reexport */ BulletListItem_style_BulletListItemStyle),
  "nt": () => (/* reexport */ CheckButton_CheckButton),
  "mT": () => (/* reexport */ CheckButtonStyle),
  "Eq": () => (/* reexport */ CommonModalDweb_CommonModalDweb),
  "E5": () => (/* reexport */ CommonModalDwebStyle),
  "X9": () => (/* reexport */ DatePickerComp_DatePickerComp),
  "S_": () => (/* reexport */ DesktopLayout_DesktopLayout),
  "bA": () => (/* reexport */ components_FlexComp_FlexComp),
  "lL": () => (/* reexport */ FlexCompStyle),
  "rc": () => (/* reexport */ components_FormattedText_FormattedText),
  "yZ": () => (/* reexport */ TextStyles_H2Tag),
  "FI": () => (/* reexport */ H2TagStyle),
  "vb": () => (/* reexport */ TextStyles_H3SmallTag),
  "AI": () => (/* reexport */ TextStyles_H3Tag),
  "KO": () => (/* reexport */ H3TagStyle),
  "j9": () => (/* reexport */ TextStyles_H4Tag),
  "sz": () => (/* reexport */ H4TagStyle),
  "jN": () => (/* reexport */ TextStyles_H5Tag),
  "Wl": () => (/* reexport */ H5TagStyle),
  "cu": () => (/* reexport */ ImageComponent_ImageComponent),
  "Du": () => (/* reexport */ ImageTag_ImageTag),
  "WB": () => (/* reexport */ LandingButton_LandingButton),
  "zm": () => (/* reexport */ LandingButtonStyle),
  "rU": () => (/* reexport */ MarkdownText_MarkdownText),
  "dZ": () => (/* reexport */ TextStyles_ParaTag),
  "OG": () => (/* reexport */ ParaTagStyle),
  "EU": () => (/* reexport */ RadioButton_RadioButton),
  "$m": () => (/* reexport */ RangeDatePicker_RangeDatePicker),
  "hK": () => (/* reexport */ ReactPortalComp_ReactPortalComp),
  "Ho": () => (/* reexport */ RichText_RichText),
  "LV": () => (/* reexport */ SectionDividers_SectionDividers),
  "$f": () => (/* reexport */ SectionDividersStyle),
  "qm": () => (/* reexport */ Shimmer),
  "KQ": () => (/* reexport */ ShimmerVersion2),
  "AO": () => (/* reexport */ ShimmerVersion3),
  "pF": () => (/* reexport */ TextStyles_SpanTag),
  "zs": () => (/* reexport */ SpanTagStyle),
  "$j": () => (/* reexport */ Spinner_Spinner),
  "Wz": () => (/* reexport */ TMFloatingInput_TMFloatingInput),
  "dd": () => (/* reexport */ TMInputWrap),
  "$G": () => (/* reexport */ Tags_Tags),
  "EN": () => (/* reexport */ TagsStyle),
  "jf": () => (/* reexport */ Toast_style_ToastStyle),
  "V6": () => (/* reexport */ ToolTipCompWrapper),
  "Bu": () => (/* reexport */ Toast_WebToast)
});

// UNUSED EXPORTS: BulletListItem, DatePicker, H6Tag, LandingButtonTertiary, LandingButtonWhite, Toast, getPlainText

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BackDropComp/BackDropComp.style.ts

const BackDropCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BackDropCompstyle__BackDropCompStyle",
  componentId: "sc-13xixk0-0"
})(["position:fixed;top:0;left:0;background-color:rgba(0,0,0,0.5);z-index:46;width:100%;height:", ";"], p => p.height ? `${p.height}px` : "100vh");
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BackDropComp/BackDropComp.tsx




const BackDropComp = ({
  onClose
}) => {
  const {
    0: height,
    1: setHeight
  } = (0,react.useState)(undefined);
  (0,react.useEffect)(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    if (true) {
      setHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BackDropCompStyle, {
    onClick: onClose,
    height: height,
    "data-test-id": "BackDropComp-BackDropCompStyle"
  });
};

/* harmony default export */ const BackDropComp_BackDropComp = (BackDropComp);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BulletListItem/BulletListItem.style.ts


const BulletListItem_style_BulletListItemStyle = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "BulletListItemstyle__BulletListItemStyle",
  componentId: "m828am-0"
})(["margin-bottom:20px;padding-left:20px;position:relative;font-size:18px;line-height:22px;color:", ";&:last-child{margin-bottom:0px;}&:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}"], Global/* theme.greyText */.rS.greyText, props => props.bulletColor);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/BulletListItem/BulletListItem.tsx




const BulletListItem = ({
  children,
  bulletColor = theme.darkYellowText
}) => {
  return /*#__PURE__*/_jsx(BulletListItemStyle, {
    bulletColor: bulletColor,
    "data-test-id": "BulletListItem-BulletListItemStyle",
    children: children
  });
};

/* harmony default export */ const BulletListItem_BulletListItem = ((/* unused pure expression or super */ null && (BulletListItem)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CheckButton/CheckButton.style.ts

const CheckButtonStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CheckButtonstyle__CheckButtonStyle",
  componentId: "dvx3ai-0"
})(["display:flex;align-items:baseline;cursor:pointer;", " label{margin-left:10px;flex:1;width:100%;cursor:pointer;user-select:none;}}", " input[type=\"checkbox\"]{", " visibility:hidden;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;}@supports (-moz-appearance:none){input[type=\"checkbox\"]{visibility:visible;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;width:18px;height:18px;accent-color:#008CFF;}}input[type='checkbox']::before{width:16px;height:16px;display:flex;visibility:visible;flex-shrink:0;border:1px solid #4a4a4a;border-radius:4px;background:#fff;position:absolute;top:0px;left:-2px;content:'';}input[type='checkbox']::after{content:'';display:block;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);margin:0px 0 0 4px;position:absolute;visibility:visible;top:3px;left:0px;}input[type='checkbox']:checked::before{", " border:unset;}"], props => props.margin && `margin: ${props.margin};`, props => props.travellingTo && `
 label{
  position:absolute;
  left:8px;
  bottom:8px;
 }
`, props => !props.isDisabled && `cursor: pointer;`, props => props.isDisabled ? `background: #0000004D;` : `background: #008cff;`);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CheckButton/CheckButton.tsx





const CheckButton = ({
  children,
  inputId,
  travellingTo,
  handleChange,
  inputIndex,
  isDisabled,
  isChecked = false,
  margin
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckButtonStyle, {
    margin: margin,
    travellingTo: travellingTo,
    isDisabled: isDisabled,
    "data-test-id": "CheckButton-CheckButtonStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      onChange: handleChange,
      type: "checkbox",
      id: inputId,
      checked: isChecked
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: inputId,
      id: inputId,
      "data-test-id": "CheckButton-label",
      children: children
    })]
  });
};

/* harmony default export */ const CheckButton_CheckButton = (CheckButton);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/SectionDividers/SectionDividers.style.ts

const SectionDividersStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SectionDividersstyle__SectionDividersStyle",
  componentId: "aokiou-0"
})(["background:", ";width:", ";height:", ";border-radius:", ";margin:", ";", ";", ";", ";flex-shrink:0;"], p => p.backgroundColor ? `${p.backgroundColor}` : `#f2f2f2`, p => p.width ? p.width : "unset", p => p.height ? p.height : "4px", p => p.borderRadius ? p.borderRadius : "0px", p => p.margin ? p.margin : "0px", p => p.xs && `height: 1px;`, p => p.small && `height: 10px;`, p => p.large && `height: 25px;`);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/TextStyles.style.ts




const renderFont = txtfontSize => {
  switch (txtfontSize) {
    case "xxs":
      return `
        font-size: 10px;
        line-height: 16px;
      `;

    case "xs":
      return `
        font-size: 12px;
        line-height: 16px;
      `;

    case "sm":
      return `
        font-size: 0.875rem;
        line-height: 20px;
      `;

    case "md":
      return `
        font-size: 1em;
        line-height: 22px;
      `;

    case "large":
      return `
        font-size: 18px;
        line-height: 24px;
      `;

    case "xlarge":
      return `
        font-size: 1.375rem;
        line-height: 26px;
      `;

    /* istanbul ignore next */

    case "xxlarge":
      return `
        font-size: 1.5em;
        line-height: 32px;
      `;

    /* istanbul ignore next */

    case "xxxlarge":
      return `
        font-size: 1.75em;
        line-height: 32px;
      `;

    /* istanbul ignore next */

    default:
      return `
        font-size: 0.875em;
        line-height: 20px;
      `;
  }
};

const renderFontWeight = (txtfontWeight, context) => {
  switch (txtfontWeight) {
    case "regular":
      return `
          font-weight: 400;
        `;

    case "bold":
      return `
          ${context === src.PARTNER.MMT ? "font-weight: 700" : "font-weight: 500"};
      `;

    case "black":
      return `
           ${context === src.PARTNER.MMT ? "font-weight: 900" : "font-weight: 700"};
        `;

    default:
      return `
      font-weight: 400;
    `;
  }
};

const H2TagStyle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "TextStylesstyle__H2TagStyle",
  componentId: "f0szg1-0"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], p => p.context === src.PARTNER.MMT ? "36px" : "32px", p => p.context === src.PARTNER.MMT ? "44px" : "37px", p => p.context === src.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const H3TagStyle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "TextStylesstyle__H3TagStyle",
  componentId: "f0szg1-1"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";text-align:var(--textAlign,left);font-variant-numeric:lining-nums proportional-nums;"], p => p.context === src.PARTNER.MMT ? "32px" : "24px", p => p.context === src.PARTNER.MMT ? "38px" : "28px", p => p.context === src.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const H4TagStyle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "TextStylesstyle__H4TagStyle",
  componentId: "f0szg1-2"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], p => p.context === src.PARTNER.MMT ? "24px" : "22px", p => p.context === src.PARTNER.MMT ? "28px" : "26px", p => p.context === src.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const H5TagStyle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
  displayName: "TextStylesstyle__H5TagStyle",
  componentId: "f0szg1-3"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], p => p.context === src.PARTNER.MMT ? "22px" : "18px", p => p.context === src.PARTNER.MMT ? "26px" : "21px", p => p.context === src.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const H3TagSmallStyle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "TextStylesstyle__H3TagSmallStyle",
  componentId: "f0szg1-4"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], p => p.context === src.PARTNER.MMT ? "22px" : "18px", p => p.context === src.PARTNER.MMT ? "26px" : "21px", p => p.context === src.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const TextStyles_style_H6TagStyle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
  displayName: "TextStylesstyle__H6TagStyle",
  componentId: "f0szg1-5"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], p => p.context === src.PARTNER.MMT ? "18px" : "16px", p => p.context === src.PARTNER.MMT ? "21px" : "18px", p => p.context === src.PARTNER.MMT ? "900" : "700", p => p.margin ? p.margin : "", p => p.txtcolor ? p.txtcolor : "#000");
const ParaTagStyle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "TextStylesstyle__ParaTagStyle",
  componentId: "f0szg1-6"
})(["", " ", " margin:", ";text-align:", ";color:", ";line-height:", ";text-transform:", ";& > .boldText{font-weight:700;}word-break:break-word;"], p => p.txtfontSize ? `
    ${renderFont(p.txtfontSize)}
  ` : ``, p => p.txtfontWeight && `
    ${renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined)}
  `, p => p.margin && p.margin, p => p.textAlign && p.textAlign, p => p.txtcolor && p.txtcolor, p => p.lineHeight && p.lineHeight, p => p.textTransform && p.textTransform);
const SpanTagStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TextStylesstyle__SpanTagStyle",
  componentId: "f0szg1-7"
})(["", " ", " display:inline-block;color:", ";margin:", ";text-transform:", ";word-break:break-word;"], p => p.txtfontSize ? `${renderFont(p.txtfontSize)}` : `inherit`, p => p.txtfontWeight && `
    ${renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined)}
  `, p => p.txtcolor && p.txtcolor, p => p.margin && p.margin, p => p.textTransform && p.textTransform);
const AnchorTagStyle = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TextStylesstyle__AnchorTagStyle",
  componentId: "f0szg1-8"
})(["", " ", " margin:", ";display:inline-block;color:", ";text-align:", ";text-transform:", ";", ""], p => p.txtfontSize ? `${renderFont(p.txtfontSize)}` : ``, p => p.txtfontWeight && `
    ${renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined)}
  `, p => p.margin && p.margin, p => p.txtcolor ? p.txtcolor : Global/* theme.blueText */.rS.blueText, p => p.textAlign && p.textAlign, p => p.textTransform && p.textTransform, p => p.disableState && `
    opacity:0.5;
    pointer-events:none;
    `);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TMFloatingInput/TMFloatingInput.style.ts


const TMInputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__TMInputWrap",
  componentId: "sc-1pz2vug-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;label{font-weight:700;font-size:14px;line-height:20px;color:", ";display:block;transition:all 0.3s ease;display:inline-block;position:absolute;left:10px;top:18px;text-transform:uppercase;", " ", "}", " label span{font-weight:400;text-transform:lowercase;}"], props => props.margin, props => props.inputWidth, p => p.flex ? p.flex : "", Global/* theme.greyText */.rS.greyText, props => props.placeholder && `
    color: ${Global/* theme.blueText */.rS.blueText};
    background: ${Global/* theme.blueLight */.rS.blueLight};
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    top: 5px;
    `, props => props.disableState && `
        pointer-events: none;
        color: ${Global/* theme.lightBlack */.rS.lightBlack};
    `, props => props.clickable && `
        cursor: pointer;
        background:${Global/* theme.whiteText */.rS.whiteText};
        color: ${Global/* theme.greyText */.rS.greyText}
    `);
const TMInputStyle = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "TMFloatingInputstyle__TMInputStyle",
  componentId: "sc-1pz2vug-1"
})(["background:", ";border:1px solid ", ";border-radius:4px;padding:26px 10px 10px;font-weight:700;font-size:14px;line-height:19px;display:block;width:100%;", " &:focus + label{color:", ";background:", ";font-weight:700;font-size:12px;line-height:16px;top:5px;", "}&:valid + label{color:", ";background:", ";font-weight:700;font-size:12px;line-height:16px;top:5px;", " ", " ", " ", "}", " ", " ", " &:focus{outline:none;border:1px solid ", ";background:", ";}&:valid{outline:none;border:1px solid ", ";background:", ";", "}"], Global/* theme.gray97 */.rS.gray97, Global/* theme.lightGrey */.rS.lightGrey, props => props.verifiedTag && `
        padding-right: 80px;
    `, Global/* theme.blueText */.rS.blueText, Global/* theme.blueLight */.rS.blueLight, props => props.errorState && `
        color: ${Global/* theme.redText2 */.rS.redText2};
    `, Global/* theme.greyText6 */.rS.greyText6, Global/* theme.smokeWhite */.rS.smokeWhite, props => props.isActive && `
            color: ${Global/* theme.blueText */.rS.blueText};
            background: ${Global/* theme.blueLight */.rS.blueLight};
        `, props => props.placeholder && `
            color: ${Global/* theme.blueText */.rS.blueText};
            background: ${Global/* theme.blueLight */.rS.blueLight};
        `, props => props.errorState && `
             color: ${Global/* theme.redText2 */.rS.redText2};
     `, props => props.clickable && `
        background: ${Global/* theme.whiteText */.rS.whiteText};
    `, props => props.disableState && `
        pointer-events: none;
        color:  ${Global/* theme.lightBlack */.rS.lightBlack};
        border: 1px solid ${Global/* theme.lightSilver */.rS.lightSilver};
        background: ${Global/* theme.whiteText */.rS.whiteText};
    `, props => props.clickable && `
        pointer-events: none;
        background: ${Global/* theme.whiteText */.rS.whiteText}  !important;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
    `, props => props.errorState && `
      border: 1px solid ${Global/* theme.redText2 */.rS.redText2} !important;
      background: ${Global/* theme.snowWhite */.rS.snowWhite}  !important;
    `, Global/* theme.blueText */.rS.blueText, Global/* theme.whiteText */.rS.whiteText, Global/* theme.gainsBoro */.rS.gainsBoro, Global/* theme.smokeWhite */.rS.smokeWhite, props => props.isActive && `
            border: 1px solid ${Global/* theme.blueText */.rS.blueText};
            background: ${Global/* theme.blueLight */.rS.blueLight};
        `);
const VerifiedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__VerifiedContainer",
  componentId: "sc-1pz2vug-2"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);
const InputWpr = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__InputWpr",
  componentId: "sc-1pz2vug-3"
})(["position:relative;"]);
const IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__IconContainer",
  componentId: "sc-1pz2vug-4"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CommonModalDweb/CommonModalDweb.style.ts





const modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalDwebStyle",
  componentId: "sc-1890wa2-0"
})(["position:fixed;width:", ";height:fit-content;max-height:531px;min-height:260px;overflow-y:scroll;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], p => p.customWidth ? p.customWidth : "420px", SectionDividersStyle, TMInputWrap, src.deviceType.mobile, modalAnim, TMInputWrap);
const CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalHeader",
  componentId: "sc-1890wa2-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:flex-start;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:80%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], H5TagStyle, p => p.nonClipHeading && `
     ${H5TagStyle} {
        white-space: unset;
        overflow: auto;
        width: 100%;
        span {
            overflow: auto;
            white-space: unset;
            max-width: 100%;
        }
    }
    `, src.deviceType.mobile);
const CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CrossIconWrap",
  componentId: "sc-1890wa2-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx







const CommonModalDweb = ({
  children,
  customTitle,
  handleClick,
  requiredField,
  crossIcon,
  customWidth,
  customIcon,
  errorModal,
  nonClipHeading
}) => {
  (0,react.useEffect)(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return () => {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ReactPortalComp_ReactPortalComp, {
    "data-test-id": "CommonModalDweb-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDwebStyle, {
      customWidth: customWidth,
      "data-test-id": "CommonModalDweb-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "CommonModalDweb-CommonModalHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_H5Tag, {
          color: errorModal ? Global/* theme.redText */.rS.redText : Global/* theme.blackText */.rS.blackText,
          "data-test-id": "CommonModalDweb-H5Tag",
          children: [customIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "40px",
            height: "40px",
            src: customIcon,
            "data-test-id": "CommonModalDweb-ImageComponent"
          }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
            value: customTitle,
            "data-test-id": "CommonModalDweb-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIconWrap, {
          onClick: handleClick,
          "data-test-id": "CommonModalDweb-CrossIconWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            "data-test-id": "CommonModalDweb-ImageComponent"
          })
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackDropComp_BackDropComp, {
      onClose: handleClick,
      "data-test-id": "CommonModalDweb-BackDropComp"
    })]
  });
};

/* harmony default export */ const CommonModalDweb_CommonModalDweb = (CommonModalDweb);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/index.js + 43 modules
var esm = __webpack_require__(91997);
// EXTERNAL MODULE: ../../node_modules/react-day-picker/dist/index.esm.js
var index_esm = __webpack_require__(50530);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingButton/LandingButton.style.ts



const LandingButtonStyle = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "LandingButtonstyle__LandingButtonStyle",
  componentId: "yz2hwb-0"
})(["background-image:", ";border-radius:8px;box-shadow:0px 1px 7px rgba(0,0,0,0.21);color:#fff;width:", ";height:", ";border:none;outline:none;cursor:pointer;margin:", ";flex:", ";flex-shrink:", ";display:flex;align-items:center;gap:8px;justify-content:center;position:relative;padding:12px 20px;text-transform:uppercase;", " ", " span{font-size:16px;font-weight:900;flex-shrink:0;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}"], Global/* theme.blueGradient */.rS.blueGradient, p => p.customWidth ? p.customWidth : "fit-content", p => p.customHeight ? p.customHeight : "fit-content", p => p.margin ? p.margin : "", p => p.flex ? p.flex : "unset", p => p.flexShrink ? p.flexShrink : "0", p => p.btnTheme === src.PARTNER.MMT ? `
    border-radius:8px;
    ` : p.btnTheme === src.PARTNER.GI ? `border-radius: 4px;
    background: ${Global/* theme.orange */.rS.orange};
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.14);` : "", props => props.disableState && `
  background: ${Global/* theme.greyText2 */.rS.greyText2};
  color: rgba(0, 0, 0, 0.3);
  pointer-events:none;
  `);
const ShimmerWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingButtonstyle__ShimmerWrap",
  componentId: "yz2hwb-1"
})(["position:absolute;width:68px;height:48px;z-index:12;top:-43px;animation:shimmmer 2.9s ease-in;animation-iteration-count:infinite;animation-fill-mode:backwards;@keyframes shimmmer{0%{transform:translateX(-311px);}100%{transform:translateX(311px);}}"]);
const LandingButton_style_LandingButtonWhiteStyle = (0,styled_components_browser_esm/* default */.ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonWhiteStyle",
  componentId: "yz2hwb-2"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);color:", ";span{color:", ";font-size:16px;font-weight:700;}", ""], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, props => props.disableState && `
background: ${Global/* theme.greyText2 */.rS.greyText2};
color: rgba(0, 0, 0, 0.3);
pointer-events:none;
opacity: 0.7;
`);
const LandingButton_style_LandingButtonTertiaryStyle = (0,styled_components_browser_esm/* default */.ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonTertiaryStyle",
  componentId: "yz2hwb-3"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border:1px solid ", ";height:32px;padding:9px;color:", ";span{color:", ";font-size:12px;font-weight:700;}", ""], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, Global/* theme.blueText */.rS.blueText, props => props.disableState && `
background: ${Global/* theme.greyText2 */.rS.greyText2};
color: rgba(0, 0, 0, 0.3);
pointer-events:none;
opacity: 0.7;
`);
const LandingButtonBlackOutlineStyle = (0,styled_components_browser_esm/* default */.ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonBlackOutlineStyle",
  componentId: "yz2hwb-4"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:4px;color:", ";border:1px solid black;span{color:", ";}"], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blackText */.rS.blackText, Global/* theme.blackText */.rS.blackText);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Toast/Toast.style.ts




const Toast_style_ToastStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Toaststyle__ToastStyle",
  componentId: "p382w4-0"
})(["display:flex;align-items:center;justify-content:space-between;padding:12px 18px;background:#4a4a4a;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:12px;width:436px;position:fixed;bottom:30px;right:30px;gap:8px;", "{flex-shrink:0;}", "{width:127px;}@media ", "{width:calc(100% - 32px);padding:8px 16px;right:16px;left:16px;}"], SpanTagStyle, LandingButton_style_LandingButtonTertiaryStyle, src.deviceType.mobile);
const Toast_style_CloseIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Toaststyle__CloseIconWrap",
  componentId: "p382w4-1"
})(["width:28px;height:28px;cursor:pointer;"]);
const Toast_style_ToastIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Toaststyle__ToastIcon",
  componentId: "p382w4-2"
})(["display:flex;flex-shrink:0;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DatePickerComp/DatePickerComp.style.ts



const DatePickerWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DatePickerWrap",
  componentId: "sc-3xqyqc-0"
})(["width:592px;background:#ffffff;box-sizing:border-box;display:flex;flex-direction:column;z-index:1;border-radius:4px;box-shadow:0px 1px 7px rgba(0,0,0,0.2);position:absolute;left:0;top:30px;", "{position:static;background:#fcdadb;width:fit-content;margin-bottom:16px;margin-left:16px;}", " span{font-size:14px;color:", ";}.rdp-cell{width:38px;height:38px;}.rdp-cell:hover{border-radius:0;}.rdp-weeknumber,.rdp-day{font-size:12px;width:38px;height:38px;}.rdp-day_selected,.rdp-day_selected:focus-visible{background:#eaf5ff;color:#000;border-radius:0;}.rdp-day_range_start,.rdp-day_range_end{background:#008cff;border-radius:0px 2px 2px 0px;color:#fff;}.rdp-head_cell{font-weight:700;font-size:12px;line-height:16px;color:#9b9b9b;}.rdp-caption_label{font-weight:400;font-size:18px;line-height:25px;color:#000;}.rdp-caption_label .boldText{font-weight:700;}.rdp-day_today{font-weight:400;}.rdp-button svg{display:none;}.rdp-button:hover:not([disabled]):not(.rdp-day_selected){background:#eaf5ff;border-radius:0;}.rdp-nav_button_previous:before,.rdp-nav_button_next:before{position:absolute;top:20px;content:\"\";width:20px;height:2px;background:#008cff;border-radius:2px;background-image:none;}.rdp-nav_button_previous:after{left:7px;transform:rotate(-45deg);}.rdp-nav_button_next:after{right:7px;transform:rotate(135deg);}.rdp-nav_button_previous:after,.rdp-nav_button_next:after{position:absolute;top:17px;content:\"\";width:8px;height:8px;background-image:none;border-top:solid 2px #008cff;border-left:solid 2px #008cff;}"], Toast_style_ToastStyle, Toast_style_ToastStyle, Global/* theme.redText */.rS.redText);
const DateLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DateLabel",
  componentId: "sc-3xqyqc-1"
})(["background:#ffffff;border-radius:2px;padding:0 8px;", ""], p => p.activeTab && `
    background: #eaf5ff;
    border: 1px solid #008cff;
    border-radius: 2px;
    `);
const DateTab = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "DatePickerCompstyle__DateTab",
  componentId: "sc-3xqyqc-2"
})(["display:flex;padding:10px 15px;border-radius:4px 4px 0px 0px;background-color:#f2f2f2;"]);
const DateTabList = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "DatePickerCompstyle__DateTabList",
  componentId: "sc-3xqyqc-3"
})(["cursor:pointer;display:flex;align-items:center;gap:4px;margin-right:10px;&:last-child{margin-right:unset;}"]);
const ErrorToast = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__ErrorToast",
  componentId: "sc-3xqyqc-4"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
const DobPickerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DobPickerStyle",
  componentId: "sc-3xqyqc-5"
})(["border-radius:4px;border:0px solid #979797;background:#fff;box-shadow:0px 1px 6px 0px rgba(0,0,0,0.2);width:300px;.rdp-dropdown_year,.rdp-dropdown_month{border-radius:4px;border:1px solid #4a4a4a;padding:0 8px;}.rdp-day_selected,.rdp-day_selected:focus-visible,.rdp-day_selected:hover{border-radius:2px 0px 0px 2px;background:#008cff;color:#fff;}.rdp-head{color:#9b9b9b;text-align:center;font-size:12px;font-weight:700;}.rdp-weeknumber,.rdp-day{font-size:12px;}"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DatePickerComp/DatePickerComp.tsx





 // import "react-day-picker/dist/style.css";




const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const DatePickerComp = ({
  startDateLabel,
  endDateLabel,
  from,
  to,
  maxEndDate,
  dateTab,
  handleDateTab,
  handleDayClick,
  selected,
  showToast,
  toastMessage
}) => {
  const weekDayNameFormatter = date => {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      "data-test-id": "DatePickerComp-weekDayNameFormatter",
      children: date.toDateString()[0]
    });
  };

  const monthNameFormatter = date => {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      "data-test-id": "DatePickerComp-monthNameFormatter",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
        "data-test-id": "DatePickerComp-monthNameFormatter-b",
        children: MONTHS[date.getMonth()]
      }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: date.getFullYear().toString().slice(-2)
      })]
    });
  };

  const disabledDays = date => {
    return (0,esm/* isBefore */.RRz)((0,esm/* startOfDay */.b7Q)(date), (0,esm/* startOfDay */.b7Q)(new Date())) || !!(maxEndDate && (0,esm/* isAfter */.AxD)(date, maxEndDate));
  };

  const {
    0: currentMonth,
    1: setCurrentMonth
  } = (0,react.useState)(new Date());
  (0,react.useEffect)(() => {
    if (from && to) {
      setCurrentMonth(from);
    }
  }, [from, to]);

  const handleMonthChange = month => {
    setCurrentMonth(month);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DatePickerWrap, {
    id: "datePickerContainer",
    "data-test-id": "DatePickerComp-DatePickerWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DateTab, {
      "data-test-id": "DatePickerComp-DateTab",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DateTabList, {
        onClick: () => handleDateTab?.(0),
        "data-test-id": "DatePickerComp-DateTabList",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "sm",
          "data-test-id": "DatePickerComp-SpanTag",
          children: startDateLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateLabel, {
          activeTab: dateTab == 0,
          "data-test-id": "DatePickerComp-DateLabel",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "sm",
            fontWeight: dateTab == 0 ? "bold" : "regular",
            color: dateTab == 0 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
            "data-test-id": "DatePickerComp-SpanTag",
            children: from ? (0,utils/* calendarLabelFormatter */.IZ)(from) : "Select"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateTabList, {
        "data-test-id": "DatePickerComp-DateTabList",
        children: "-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DateTabList, {
        onClick: () => handleDateTab?.(1),
        "data-test-id": "DatePickerComp-DateTabList",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "sm",
          "data-test-id": "DatePickerComp-SpanTag",
          children: endDateLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateLabel, {
          activeTab: dateTab == 0,
          "data-test-id": "DatePickerComp-DateLabel",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontWeight: dateTab == 1 ? "bold" : "regular",
            fontSize: "sm",
            color: dateTab == 1 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
            "data-test-id": "DatePickerComp-SpanTag",
            children: to ? (0,utils/* calendarLabelFormatter */.IZ)(to) : "Select"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* DayPicker */._W, {
      mode: "range",
      numberOfMonths: 2,
      selected: selected,
      disabled: disabledDays,
      onDayClick: handleDayClick,
      formatters: {
        formatWeekdayName: weekDayNameFormatter,
        formatCaption: monthNameFormatter
      },
      month: currentMonth,
      onMonthChange: handleMonthChange,
      "data-test-id": "DatePickerComp-DayPicker"
    }), showToast && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorToast, {
      "data-test-id": "DatePickerComp-ErrorToast",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.redText */.rS.redText,
        "data-test-id": "DatePickerComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
          value: toastMessage,
          "data-test-id": "DatePickerComp-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ const DatePickerComp_DatePickerComp = (DatePickerComp);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/icons/index.tsx + 8 modules
var icons = __webpack_require__(51046);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DesktopLayout/DesktopLayout.style.ts



const DesktopLayoutStyleSectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSectionWrap",
  componentId: "n4shqf-0"
})(["position:relative;padding-top:6px;img,picture{flex-shrink:0;}&:after{position:fixed;width:100%;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/blue_Grad_Bg_563cf7d36a.png\");background-repeat:no-repeat;background-size:cover;content:\"\";top:0;left:0;height:87%;z-index:1;}", " @media ", "{padding-top:0px;&:after{height:0;background:transparent;background-image:none;}}"], p => p.pageTheme === src.PARTNER.MMT && p.landingPageProp ? `
        &:after {
        background:transparent;
        }
        ${LandingButtonStyle}{
            border-radius:38px;
        }
` : p.pageTheme === src.PARTNER.GI && p.landingPageProp ? `
    &:after {
    background:transparent;
    }
    ${LandingButtonStyle}{
        border-radius:30px;
    }
` : p.pageTheme === src.PARTNER.MYBIZ && p.landingPageProp ? `
    &:after {
    background:transparent;
    }
    ${LandingButtonStyle}{
        border-radius:30px;
    }
` : "", src.deviceType.mobile);
const DesktopLayoutStyleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSection",
  componentId: "n4shqf-1"
})(["width:", ";margin:0 auto;display:flex;gap:", ";height:100%;z-index:3;position:relative;justify-content:space-between;align-items:", ";flex-direction:", ";margin-bottom:", ";background:", ";", " @media ", "{background:#f2f2f2;width:100%;gap:24px;padding:56px 16px 0;margin-top:0;border-radius:0px;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/mob_Bg_76aceb3f35.png\");background-repeat:no-repeat;background-size:contain;flex-direction:column;", "}"], p => p.landingMargin ? "1200px" : "1230px", p => p.landingMargin ? "88px" : "58px", p => p.alignCenter ? "flex-start" : "baseline", p => p.flexDirection ? "column" : "row", p => p.landingMargin ? "70px" : "", p => p.landingMargin ? "#fff" : "transparent", p => p.pageTheme === src.PARTNER.MMT && p.landingMargin ? `
            padding:68px 40px 40px;
            border-radius:10px;
            margin-top:26px;
` : p.pageTheme === src.PARTNER.GI && p.landingMargin ? `
            padding:38px 40px 40px;
            border-radius:10px;
            margin-top:26px;
` : "", src.deviceType.mobile, p => p.landingMargin && `
            padding-bottom: 238px;
            margin-bottom: -236px ;
        `);
const DesktopLayoutBotttomSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutBotttomSection",
  componentId: "n4shqf-2"
})(["margin-top:20px;display:flex;gap:60px;height:100%;z-index:2;position:relative;align-items:flex-start;flex-direction:column;@media ", "{gap:56px;z-index:3;}"], src.deviceType.mobile);
const DesktopLayoutLeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutLeftSection",
  componentId: "n4shqf-3"
})(["display:flex;flex-direction:column;align-self:flex-start;padding-top:", ";gap:32px;margin:", ";height:", ";flex:1;margin-left:", ";position:sticky;top:155px;width:498px;", " @media ", "{margin-left:0;margin-top:11px;padding-top:0;height:unset;gap:10px;position:static;width:100%;}"], p => p.leftSectionHeight ? "" : "0px", p => p.leftSectionMargin ? p.leftSectionMargin : "", p => p.leftSectionHeight ? "100%" : "calc(708px - 130px)", p => p.leftSectionHeight ? "" : "15px", p => p.pageTheme === src.PARTNER.MMT && p.leftSectionHeight ? `
            margin-top:40px;
` : p.pageTheme === src.PARTNER.GI ? `
            margin-top:40px;
` : "", src.deviceType.mobile);
const DesktopLayoutRightSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutRightSection",
  componentId: "n4shqf-4"
})(["width:", ";flex-shrink:0;padding-bottom:", ";display:flex;flex-direction:column;z-index:1;gap:16px;padding:", ";margin-right:", ";min-height:490px;margin-top:40px;&::-webkit-scrollbar{display:none;}@media ", "{width:100%;overflow-y:unset;padding:0;margin-right:0;height:unset;margin-top:0;", "}"], p => p.rightSectionHeight ? "592px" : "622px", p => p.rightSectionHeight ? "" : "40px", p => p.rightSectionHeight ? "" : "56px 30px 0", p => p.rightSectionHeight ? "" : "-15px", src.deviceType.mobile, p => !p.rightSectionHeight && `
        margin-right: -16px;
        margin-left: -16px;
        width: -webkit-fill-available;
        overflow-y: scroll;
        flex-shrink:unset;
        `);
const DesktopLayoutHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutHeading",
  componentId: "n4shqf-5"
})(["display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/DesktopLayout/DesktopLayout.tsx










const DesktopLayout = ({
  title,
  leftComp,
  rightComp,
  bottomComp,
  headingComp,
  height,
  alignCenter,
  leftSectionMargin,
  rightSectionHeight,
  leftSectionHeight,
  landingMargin,
  subTitle,
  shimmer,
  landingPageProp,
  goToMyOrders,
  showMyOrders = true
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    0: windowHeight,
    1: setWindowHeight
  } = (0,react.useState)(undefined);
  (0,react.useEffect)(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    if (true) {
      setWindowHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutStyleSectionWrap, {
    id: "pageId",
    height: height,
    pageTheme: context ? context : undefined,
    landingPageProp: landingPageProp,
    "data-test-id": "DesktopLayout-DesktopLayoutStyleSectionWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutStyleSection, {
      landingMargin: landingMargin,
      alignCenter: alignCenter,
      pageTheme: context ? context : undefined,
      "data-test-id": "DesktopLayout-DesktopLayoutStyleSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutLeftSection, {
        leftSectionHeight: leftSectionHeight,
        leftSectionMargin: leftSectionMargin,
        pageTheme: context ? context : undefined,
        "data-test-id": "DesktopLayout-DesktopLayoutLeftSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: shimmer ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            flexDirection: "column",
            gap: "4px",
            "data-test-id": "DesktopLayout-FlexComp",
            children: [subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer, {
              width: "375px",
              height: "38px",
              "data-test-id": "DesktopLayout-Shimmer"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer, {
              width: "100%",
              height: "56px",
              "data-test-id": "DesktopLayout-Shimmer"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [subTitle && (device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H4Tag, {
              margin: device == "lg" ? "40px 0 0" : "",
              color: "#CF8100",
              "data-test-id": "DesktopLayout-H4Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
                value: subTitle,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
              fontSize: "md",
              fontWeight: "black",
              color: "#CF8100",
              "data-test-id": "DesktopLayout-ParaTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
                value: subTitle,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            })), device == "lg" ? title?.html ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
              value: title,
              "data-test-id": "DesktopLayout-FormattedText"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
              "data-test-id": "DesktopLayout-H2Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
                value: title,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            }) : title?.html ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
              value: title,
              "data-test-id": "DesktopLayout-FormattedText"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H4Tag, {
              "data-test-id": "DesktopLayout-H4Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
                value: title,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            })]
          })
        }), leftComp]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutRightSection, {
        rightSectionHeight: rightSectionHeight,
        "data-test-id": "DesktopLayout-DesktopLayoutRightSection",
        children: [context && showMyOrders && landingPageProp && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          alignSelf: "flex-end",
          isCursorPointer: true,
          gap: "4px",
          alignItems: "center",
          margin: "0 0 8px",
          "data-test-id": "DesktopLayout-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
            fontWeight: "bold",
            handleClick: goToMyOrders,
            "data-test-id": "DesktopLayout-AnchorTag",
            children: "My Orders"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* ArrowRight */.ol, {
            width: 16,
            height: 16,
            "data-test-id": "DesktopLayout-ArrowRight"
          })]
        }), rightComp]
      })]
    }), bottomComp && /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopLayoutBotttomSection, {
      "data-test-id": "DesktopLayout-DesktopLayoutBotttomSection",
      children: bottomComp
    })]
  });
};

/* harmony default export */ const DesktopLayout_DesktopLayout = (DesktopLayout);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/FlexComp/FlexComp.style.ts


const renderAlign = alignItems => {
  switch (alignItems) {
    case "center":
      return `align-items: center;`;

    case "baseline":
      return `align-items: baseline;`;

    case "flex-start":
      return `align-items:flex-start;`;

    case "flex-end":
      return `align-items:flex-end;`;

    default:
      return `align-items:center;`;
  }
};

const renderAlignSelf = alignSelf => {
  switch (alignSelf) {
    case "center":
      return `align-self: center;`;

    case "baseline":
      return `align-self: baseline;`;

    case "flex-start":
      return `align-self:flex-start;`;

    case "flex-end":
      return `align-self:flex-end;`;

    default:
      return `align-self:unset;`;
  }
};

const renderJustify = justifyContent => {
  switch (justifyContent) {
    case "center":
      return `justify-content:center;`;

    case "flex-start":
      return `justify-content:flex-start;`;

    case "end":
      return `justify-content:end;`;

    case "space-between":
      return `justify-content:space-between;`;

    case "inherit":
      return `justify-content:inherit;`;

    case "right":
      return `justify-content:right;`;

    default:
      return `justify-content:center;`;
  }
};

const renderDir = flexDirection => {
  switch (flexDirection) {
    case "row":
      return `flex-direction:row;`;

    case "column":
      return `flex-direction:column;`;

    case "row-reverse":
      return `flex-direction:row-reverse;`;

    case "column-reverse":
      return `flex-direction:column-reverse;`;

    default:
      return `flex-direction:row;`;
  }
};

const FlexCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FlexCompstyle__FlexCompStyle",
  componentId: "sc-82xs04-0"
})(["display:flex;position:relative;cursor:", ";", " ", " ", " ", " gap:", ";flex:", ";flex-shrink:", ";margin:", ";padding:", ";border-bottom:", ";border-top:", ";background:", ";border-radius:", ";height:", ";width:", ";box-shadow:", ";pointer-events:auto;flex-wrap:", ";"], props => props.isCursorPointer ? "pointer" : "default", p => p.alignItems && `
    ${renderAlign(p.alignItems)}
  `, p => p.alignSelf && `
    ${renderAlignSelf(p.alignSelf)}
  `, p => p.justifyContent && `
    ${renderJustify(p.justifyContent)}
  `, p => p.flexDirection && `
    ${renderDir(p.flexDirection)}
  `, p => p.gap ? p.gap : "0", p => p.flex ? p.flex : "unset", p => p.flexShrink ? p.flexShrink : "unset", p => p.margin ? p.margin : "unset", p => p.padding ? p.padding : "0", p => p.borderBottom ? p.borderBottom : "none", p => p.borderTop ? p.borderTop : "none", p => p.bgColor ? p.bgColor : "transparent", p => p.borderRadius ? p.borderRadius : "0", p => p.height ? p.height : "unset", p => p.width ? p.width : "unset", p => p.boxShadow ? p.boxShadow : "none", p => p.flexWrap ? p.flexWrap : "");
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/FlexComp/FlexComp.tsx




const FlexComp_FlexComp = ({
  children,
  flexDirection,
  alignItems,
  justifyContent,
  gap,
  margin,
  borderBottom,
  borderTop,
  padding,
  flex,
  bgColor,
  borderRadius,
  height,
  flexShrink,
  handleClick,
  boxShadow,
  width,
  isCursorPointer = false,
  flexWrap,
  alignSelf
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FlexCompStyle, {
    flexDirection: flexDirection,
    alignItems: alignItems,
    justifyContent: justifyContent,
    isCursorPointer: isCursorPointer ? true : handleClick ? true : false,
    gap: gap,
    margin: margin,
    borderBottom: borderBottom,
    borderTop: borderTop,
    padding: padding,
    flex: flex,
    bgColor: bgColor,
    borderRadius: borderRadius,
    height: height,
    flexShrink: flexShrink,
    width: width,
    boxShadow: boxShadow,
    onClick: handleClick,
    flexWrap: flexWrap,
    alignSelf: alignSelf,
    "data-test-id": "FlexComp-FlexCompStyle",
    children: children
  });
};

/* harmony default export */ const components_FlexComp_FlexComp = (FlexComp_FlexComp);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/FormattedText/FormattedText.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* Every text node can be of either of the three formats - 
1. string - "Hello"
2. text obj with value and styles - 
   text: {
    value: "Travel Assistance",
    styles: {
      color: "#000000",
      fontFamily: "fontSansBold",
    },
  }
3. Array of text objs with value and styles - 
   text: [
    {
      value: "Travel Assistance",
      styles: {
        color: "#000000",
        fontFamily: "fontSansBold",
      },
    },
  ]
*/




const ListItemText = ({
  text,
  style
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
    style: {
      flexDirection: "row"
    },
    "data-test-id": "ListItemText",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      style: style,
      children: "\u2022 "
    }), text && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      style: style,
      children: text
    })]
  });
};

const getPlainText = data => {
  if (!data) {
    return "";
  } else if (typeof data === "string") {
    return data;
  } else if (data?.text) {
    const {
      text
    } = data;

    if (Array.isArray(text)) {
      return text.map(node => node.value).join("");
    } else if (typeof text === "object") {
      return text?.value || "";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

const FormattedText_FormattedText = ({
  value,
  baseStyle
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  let isList = false;

  if (!value) {
    return null;
  }

  let returnValue = null;

  if (typeof value === "string") {
    returnValue = value;
  } else if (value?.text) {
    const {
      text,
      displayType
    } = value;

    if (displayType === "UNORDERED_LIST") {
      isList = true;
    }

    if (Array.isArray(text)) {
      returnValue = text.map((node, index) => {
        const mobileStyle = node.styles?.mobile;

        const combinedStyles = _objectSpread(_objectSpread({}, node?.styles), device === "sm" && _objectSpread({}, mobileStyle));

        const textValue = node?.value;
        return node.value ? /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
          children: isList ? /*#__PURE__*/(0,jsx_runtime.jsx)(ListItemText, {
            text: textValue ? textValue : "",
            style: node?.styles,
            "data-test-id": "FormattedText-ListItemText"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            style: combinedStyles,
            children: node.value
          }, index)
        }, index) : null;
      });
    } else if (typeof text === "object") {
      const mobileStyle = text?.styles?.mobile;

      const combinedStyles = _objectSpread(_objectSpread({}, text?.styles), device === "sm" && _objectSpread({}, mobileStyle));

      returnValue = text?.value ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        style: combinedStyles,
        "data-test-id": "FormattedText",
        children: text.value
      }) : null;
    } else {
      returnValue = text;
    }
  }

  return value?.html ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    dangerouslySetInnerHTML: {
      __html: value.html
    },
    style: baseStyle ?? {}
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    style: baseStyle ?? {},
    children: returnValue
  });
};

/* harmony default export */ const components_FormattedText_FormattedText = (FormattedText_FormattedText);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ImageComponent/ImageComponent.tsx



const ImageComponent_ImageComponent = ({
  src,
  width,
  height,
  alt = "",
  loading = "lazy",
  className = "",
  id = "",
  cdnUrlWidths = [],
  sizes = "",
  margin
}) => {
  const imgStyle = margin ? {
    margin
  } : {};

  if (!src || !width || !height) {
    return null;
  }

  if (src.endsWith && src.endsWith(".svg")) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      style: imgStyle,
      className: className,
      id: id,
      width: width,
      height: height,
      "data-test-id": "ImageComponent"
    });
  }

  const srcsetUrl = (0,utils/* generateSourceSetImageUrl */.sI)(cdnUrlWidths, src, parseInt(width));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
    "data-test-id": "ImageComponent-picture",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      "data-testid": "testID",
      srcSet: srcsetUrl,
      sizes: sizes ? sizes : width,
      "data-test-id": "ImageComponent-source"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height,
      style: imgStyle
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ImageTag/ImageTag.style.ts

const ImageTagStyle = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ImageTagstyle__ImageTagStyle",
  componentId: "sc-1k1vovp-0"
})(["display:inline-block;margin:", ";width:", ";", " flex-shrink:0;"], props => props.margin, props => props.width, props => props.showCursorPointer && ` cursor: pointer;`);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ImageTag/ImageTag.tsx



const ImageTag = ({
  src,
  width,
  alt = "image-tag",
  margin,
  height,
  showCursorPointer = false
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTagStyle, {
    src: src,
    width: width,
    margin: margin,
    height: height,
    showCursorPointer: showCursorPointer,
    alt: alt,
    "data-test-id": "ImageTag-ImageTagStyle"
  });
};

/* harmony default export */ const ImageTag_ImageTag = (ImageTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingButton/LandingButton.tsx








const LandingButton = ({
  customTitle,
  margin,
  customWidth,
  disableState,
  onClick,
  flexShrink,
  shimmerBtn,
  flex,
  btnLeftIcon,
  btnRightIcon,
  isLoading,
  buttonref
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButtonStyle, {
    ref: buttonref,
    onClick: onClick,
    customWidth: customWidth,
    margin: margin,
    flexShrink: flexShrink,
    flex: flex,
    disableState: disableState,
    btnTheme: context ? context : undefined,
    txtClipIcon: btnLeftIcon !== "" && btnRightIcon !== "",
    "data-test-id": "LandingButton-LandingButtonStyle",
    children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner_Spinner, {
      spinnerColor: "#fff",
      "data-test-id": "LandingButton-Spinner"
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [btnLeftIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "24px",
        height: "24px",
        src: btnLeftIcon,
        "data-test-id": "LandingButton-ImageComponent"
      }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.blueText */.rS.blueText,
        fontSize: "md",
        fontWeight: "black",
        "data-test-id": "LandingButton-SpanTag",
        children: customTitle
      }), shimmerBtn && /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerWrap, {
        "data-test-id": "LandingButton-ShimmerWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "../../../images/shimmerBtn.svg"
        })
      }), btnRightIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "16px",
        height: "16px",
        margin: "0 0 0 auto",
        src: btnRightIcon,
        "data-test-id": "LandingButton-ImageComponent"
      })]
    })
  });
};

/* harmony default export */ const LandingButton_LandingButton = (LandingButton);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingButton/LandingButtonTertiary.tsx






const LandingButtonTertiary = ({
  title,
  disableState,
  onClick,
  btnLeftIcon,
  btnRightIcon
}) => {
  return /*#__PURE__*/_jsxs(LandingButtonTertiaryStyle, {
    onClick: onClick,
    disableState: disableState,
    "data-test-id": "LandingButtonTertiary-LandingButtonTertiaryStyle",
    children: [btnLeftIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon,
      "data-test-id": "LandingButtonTertiary-ImageComponent"
    }), title && /*#__PURE__*/_jsx(SpanTag, {
      color: theme.blueText,
      fontSize: "xs",
      fontWeight: "bold",
      "data-test-id": "LandingButtonTertiary-SpanTag",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: title,
        "data-test-id": "LandingButtonTertiary-FormattedText"
      })
    }), btnRightIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon,
      "data-test-id": "LandingButtonTertiary-ImageComponent"
    })]
  });
};

/* harmony default export */ const LandingButton_LandingButtonTertiary = ((/* unused pure expression or super */ null && (LandingButtonTertiary)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/LandingButton/LandingButtonWhite.tsx






const LandingButtonWhite_LandingButtonWhite = ({
  customTitle,
  margin,
  customWidth,
  customHeight,
  disableState,
  onClick,
  flexShrink,
  flex,
  btnLeftIcon,
  btnRightIcon
}) => {
  return /*#__PURE__*/_jsxs(LandingButtonWhiteStyle, {
    onClick: onClick,
    customWidth: customWidth,
    customHeight: customHeight,
    margin: margin,
    flexShrink: flexShrink,
    flex: flex,
    disableState: disableState,
    "data-test-id": "LandingButtonWhite-LandingButtonWhiteStyle",
    children: [btnLeftIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon,
      "data-test-id": "LandingButtonWhite-ImageComponent"
    }), customTitle && /*#__PURE__*/_jsx(SpanTag, {
      color: theme.blueText,
      fontSize: "md",
      fontWeight: "bold",
      "data-test-id": "LandingButtonWhite-SpanTag",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: customTitle,
        "data-test-id": "LandingButtonWhite-FormattedText"
      })
    }), btnRightIcon && /*#__PURE__*/_jsx(ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon,
      "data-test-id": "LandingButtonWhite-ImageComponent"
    })]
  });
};

/* harmony default export */ const LandingButton_LandingButtonWhite = ((/* unused pure expression or super */ null && (LandingButtonWhite_LandingButtonWhite)));
// EXTERNAL MODULE: ../../node_modules/react-markdown/index.js + 29 modules
var react_markdown = __webpack_require__(2324);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/MarkdownText/MarkdownText.tsx




const MarkdownText = ({
  value
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* default */.Z, {
    components: {
      p: "span"
    },
    "data-test-id": "MarkdownText-ReactMarkdown",
    children: value
  });
};

/* harmony default export */ const MarkdownText_MarkdownText = (MarkdownText);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RadioButton/RadioButton.style.ts

const RadioButtonStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RadioButtonstyle__RadioButtonStyle",
  componentId: "g4c4b9-0"
})(["", " display:flex;", " label{user-select:none;}input{display:none;}[type=\"radio\"]:checked,[type=\"radio\"]:not(:checked){position:absolute;left:-9999px;}[type=\"radio\"]:checked + label,[type=\"radio\"]:not(:checked) + label{position:relative;padding-left:24px;cursor:pointer;display:inline-flex;color:#666;width:100%;", "}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{content:\"\";position:absolute;left:0;top:0px;width:15px;height:15px;border:1px solid #008cff;border-radius:100%;background:#fff;", "}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{content:\"\";width:9px;height:9px;background:#008cff;position:absolute;top:3px;left:3px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;", "}[type=\"radio\"]:not(:checked) + label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}[type=\"radio\"]:checked + label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}"], p => p.isPadding && `
    padding: 16px 10px;
`, p => p.showLabel && `
        width: 100%;
`, p => !p.showLabel && `
        margin-top:-12px
`, p => !p.showLabel && `
        margin-top:-12px
`, p => !p.showLabel && `
        margin-top:-12px
`);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RadioButton/RadioButton.tsx





const RadioButton = ({
  children,
  activeBtn,
  handleChange,
  inputIndex,
  inputId,
  isPadding,
  showLabel = true
}) => {
  const handleRadioChange = () => {
    if (handleChange && inputIndex !== undefined) {
      handleChange(inputIndex);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RadioButtonStyle, {
    isPadding: isPadding,
    onChange: handleRadioChange,
    showLabel: showLabel,
    "data-test-id": "RadioButton-RadioButtonStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "radio",
      onChange: handleRadioChange,
      checked: activeBtn,
      id: inputId,
      name: "radio-group"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: inputId,
      "data-test-id": "RadioButton-label",
      children: children
    })]
  });
};

/* harmony default export */ const RadioButton_RadioButton = (RadioButton);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/utils/index.js

// Holidays array
const holidays = [{
  date: "2023-03-08",
  name: "Holi"
}, {
  date: "2023-03-30",
  name: "Ram Navami"
}, {
  date: "2023-04-04",
  name: "Mahavir Jayanti"
}, {
  date: "2023-04-07",
  name: "Good Friday"
}, {
  date: "2023-04-22",
  name: "Eid-ul-fitr"
}, {
  date: "2023-05-01",
  name: "Labor Day"
}, {
  date: "2023-05-05",
  name: "Budhha Purnima"
}, {
  date: "2023-07-29",
  name: "Muharram"
}, {
  date: "2023-08-15",
  name: "Independence Day"
}, {
  date: "2023-08-29",
  name: "Onam"
}, {
  date: "2023-08-30",
  name: "Raksha Bandhan"
}, {
  date: "2023-09-07",
  name: "Ganesh Chaturthi"
}, {
  date: "2023-10-02",
  name: "Gandhi Jayanti"
}, {
  date: "2023-10-24",
  name: "Dussehra"
}, {
  date: "2023-10-28",
  name: "Valmiki Jayanti"
}, {
  date: "2023-11-12",
  name: "Diwali"
}, {
  date: "2023-11-27",
  name: "Guru Nanak Jayanti"
}, {
  date: "2023-12-25",
  name: "Christmas"
}, {
  date: "2024-01-01",
  name: "New Year's Day"
}]; // Get all days in a month

function getDaysInMonth(year, month, showHolidays) {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const days = [];
  let holidaysCount = 0;

  for (let i = 1; i <= daysInMonth; i++) {
    /* istanbul ignore next */
    if (showHolidays) {
      const dateTimestamp = Date.UTC(year, month, i);
      let isHoliday = false;
      let holidayName = "";
      holidays.forEach(holiday => {
        const holidayDate = new Date(holiday.date);
        const holidayTimestamp = Date.UTC(holidayDate.getFullYear(), holidayDate.getMonth(), holidayDate.getDate());

        if (dateTimestamp === holidayTimestamp) {
          isHoliday = true;
          holidayName = holiday.name;
          holidaysCount++;
        }
      });
      days.push({
        date: new Date(year, month, i),
        isHoliday: isHoliday,
        holidayName: holidayName
      });
    } else {
      days.push({
        date: new Date(year, month, i)
      });
    }
  }

  return {
    days,
    holidaysCount
  };
} // Get all calendar data

function getCalendarData(startDate, endDate, showHolidays) {
  let currentDate = startDate ? new Date(startDate) : new Date();
  const lastDate = endDate ? new Date(endDate) : new Date(currentDate.getTime() + 365 * 24 * 60 * 60 * 1000);
  let monthData = [];

  while (currentDate <= lastDate) {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const lastDay = new Date(year, month + 1, 0).getDate();
    const daysInMonth = getDaysInMonth(year, month, showHolidays);
    monthData.push({
      month: month,
      year: year,
      daysInMonth: daysInMonth,
      firstDayOfWeek: firstDay
    });
    currentDate.setMonth(month + 1);
    currentDate.setDate(1);
  }

  return monthData;
} // Generate empty cell before start date

function emptyCellBefore(data, daysInMonth) {
  const daysBefore = new Array(data).fill(null).map((_, i) => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "empty",
    "data-test-id": "daysBefore"
  }, `empty-${i}`));
  return daysBefore;
} // Generate empty cell after end date

function emptyCellAfter(data, daysInMonth) {
  const emptyDaysAfter = new Array(7 - (emptyCellBefore().length + daysInMonth.days.length) % 7).fill(null).map((_, i) => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "empty",
    "data-test-id": "emptyDaysAfter"
  }, `empty-after-${i}`));
  return emptyDaysAfter;
}
const formatDate = dateString => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1; // Month starts from 0, so we add 1 to get the correct month.

  const year = date.getFullYear() % 100; // Get the last two digits of the year.

  return `${day}/${month}/${year}`;
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.style.ts

const CalenderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderWrap",
  componentId: "sc-1ts3bpj-0"
})(["flex:1;overflow-y:auto;padding-bottom:10px;"]);
const CalenderMonthName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderMonthName",
  componentId: "sc-1ts3bpj-1"
})(["background-color:#fff;padding:20px 16px;font-size:16px;font-weight:700;color:#4a4a4a;display:flex;align-items:center;"]);
const CalenderDays = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderDays",
  componentId: "sc-1ts3bpj-2"
})(["display:grid;grid-template-columns:repeat(7,1fr);border-bottom:1px solid #e7e7e7;background-color:#f2f2f2;"]);
const CalenderDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderDate",
  componentId: "sc-1ts3bpj-3"
})(["border-left:1px solid #e7e7e7;border-top:1px solid #e7e7e7;padding:20px 5px;display:flex;align-items:center;justify-content:center;background-color:#fff;position:relative;", " ", " ", ""], p => p.isSelected && ` background-color: #008cff;`, p => p.isWithinRange && `background-color: #f0f8ff;`, p => p.isDisabled && ` pointer-events: none;`);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.tsx









const Calendar = ({
  handleDayClick,
  startDate,
  endDate,
  monthNameType,
  yearType,
  selected,
  numberOfMonth = 13,
  maxEndDate
}) => {
  // const [sDate, setSDate] = useState(startDate);
  // const [eDate, setEDate] = useState(endDate);
  const monthRefs = (0,react.useRef)([]);
  const calendarData = getCalendarData(new Date(), maxEndDate);
  (0,react.useEffect)(() => {
    if (selected?.from) {
      const selectedMonth = selected.from.getMonth();
      const selectedYear = selected.from.getFullYear();
      const refIndex = calendarData?.findIndex(({
        month,
        year
      }) => month === selectedMonth && year === selectedYear);
      refIndex && monthRefs.current[refIndex]?.scrollIntoView({
        behavior: "auto",
        block: "start"
      });
    }
  }, [selected, calendarData]);

  const disabledDays = date => {
    return isBefore((0,esm/* startOfDay */.b7Q)(date), (0,esm/* startOfDay */.b7Q)(new Date())) || !!(maxEndDate && isAfter(date, maxEndDate));
  };

  const isBefore = (date1, date2) => date1 < date2;

  const isAfter = (date1, date2) => date1 > date2;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderWrap, {
    "data-test-id": "Calendar-CalenderWrap",
    children: calendarData?.map(({
      month,
      year,
      daysInMonth,
      firstDayOfWeek
    }, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        ref: ref => monthRefs.current[index] = ref,
        "data-test-id": "Calendar",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderMonthName, {
          "data-test-id": "Calendar-CalenderMonthName",
          children: [new Date(year, month).toLocaleString("en-us", {
            month: monthNameType
          }), " ", "\xA0", new Date(year, month).toLocaleString("en-us", {
            year: yearType
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderDays, {
          "data-test-id": "Calendar-CalenderDays",
          children: [emptyCellBefore(firstDayOfWeek, daysInMonth), daysInMonth.days.map(day => {
            const d = new Date();
            const curDate = d.getDate();
            const curMonth = d.getMonth();
            const curYear = d.getFullYear();
            const isSelected = day.date.getTime() === (selected?.from && selected?.from.getTime()) || day.date.getTime() === (selected?.to && selected?.to.getTime());
            const isWithinRange = selected && day.date > selected.from && day.date < selected.to;
            const isDisabled = disabledDays(day.date);
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderDate, {
              isSelected: isSelected,
              isWithinRange: isWithinRange,
              isDisabled: isDisabled,
              onClick: handleDayClick ? () => handleDayClick(day.date) : () => {},
              "data-test-id": "Calendar-CalenderDate",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                color: isSelected ? Global/* theme.whiteText */.rS.whiteText : isDisabled ? Global/* theme.greyText7 */.rS.greyText7 : Global/* theme.blackText */.rS.blackText,
                "data-test-id": "Calendar-SpanTag",
                children: day.date.getDate()
              })
            }, `${day}`);
          }), emptyCellAfter(firstDayOfWeek, daysInMonth)]
        })]
      }, `${index}`);
    })
  });
};

/* harmony default export */ const Calendar_Calendar = (Calendar);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.style.ts

const CalenderFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFooterWrap",
  componentId: "sc-16h4vsx-0"
})(["background-color:#fff;padding:16px;box-shadow:0 0 6px rgba(0,0,0,0.2);position:relative;"]);
const CalenderFootRange = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFootRange",
  componentId: "sc-16h4vsx-1"
})(["display:flex;align-items:center;gap:8px;margin-bottom:16px;"]);
const CalFootRangeCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalFootRangeCol",
  componentId: "sc-16h4vsx-2"
})(["flex:1;background-color:#f7f7f7;border:1px solid #e7e7e7;border-radius:2px;padding:8px 10px;height:54px;position:relative;", " &:last-child{padding:8px 10px 8px 16px;}"], p => p.selected && `
        border: 1px solid #008CFF;
        background: #F9FCFF;
    `);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.tsx








const CalendarFooter = ({
  checkinDate,
  checkoutDate,
  onSubmitButtonPress
}) => {
  const {
    0: selected,
    1: setSelected
  } = (0,react.useState)(0);
  (0,react.useEffect)(() => {
    checkinDate && setSelected(1);
    checkinDate && checkoutDate && setSelected(0);
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderFooterWrap, {
    "data-test-id": "CalendarFooter-CalenderFooterWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderFootRange, {
      "data-test-id": "CalendarFooter-CalenderFootRange",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalFootRangeCol, {
        selected: selected === 0,
        "data-test-id": "CalendarFooter-CalFootRangeCol",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 0 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "CalendarFooter-ParaTag",
          children: "start date"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontWeight: "bold",
          "data-test-id": "CalendarFooter-ParaTag",
          children: checkinDate ? formatDate(checkinDate) : "-"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalFootRangeCol, {
        selected: selected === 1,
        "data-test-id": "CalendarFooter-CalFootRangeCol",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 1 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "CalendarFooter-ParaTag",
          children: "end date"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontWeight: "bold",
          "data-test-id": "CalendarFooter-ParaTag",
          children: checkoutDate ? formatDate(checkoutDate) : "-"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customWidth: "100%",
      onClick: onSubmitButtonPress ? () => onSubmitButtonPress(checkinDate, checkoutDate) : () => {},
      customTitle: "Confirm",
      disableState: !checkinDate || !checkoutDate,
      "data-test-id": "CalendarFooter-LandingButton"
    })]
  });
};

/* harmony default export */ const CalendarFooter_CalendarFooter = (CalendarFooter);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.style.ts

const CalenderHeaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarHeaderstyle__CalenderHeaderWrap",
  componentId: "w3gpol-0"
})(["background-color:#fff;padding:12px 16px;position:sticky;display:flex;align-items:center;top:0;z-index:6;"]);
const CalHeaderBackBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "CalendarHeaderstyle__CalHeaderBackBtn",
  componentId: "w3gpol-1"
})(["width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;background:transparent;outline:0;border:0;position:relative;flex-shrink:0;margin-right:15px;&:after{content:\"\";border:solid #000;border-width:0 2px 2px 0;padding:5px;transform:rotate(135deg);position:absolute;left:2;}&:before{width:16px;height:2px;background-color:#000;content:\"\";flex-shrink:0;}"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.tsx






const CalendarHeader = ({
  checkinDate,
  checkoutDate,
  onBackPress
}) => {
  const {
    0: text,
    1: setText
  } = (0,react.useState)("Select Travel Dates");
  (0,react.useEffect)(() => {
    checkinDate && setText("Select Travel Dates");
    checkinDate && checkoutDate && setText("Select Travel Dates");
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderHeaderWrap, {
    "data-test-id": "CalendarHeader-CalenderHeaderWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CalHeaderBackBtn, {
      onClick: onBackPress,
      "data-test-id": "CalendarHeader-CalHeaderBackBtn"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      fontWeight: "bold",
      fontSize: "md",
      "data-test-id": "CalendarHeader-SpanTag",
      children: text
    })]
  });
};

/* harmony default export */ const CalendarHeader_CalendarHeader = (CalendarHeader);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.style.ts

const WeekDayWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WeekDaysstyle__WeekDayWrap",
  componentId: "sc-5sctr8-0"
})(["background-color:#fff;padding:2px 0;position:sticky;top:49px;z-index:1;box-shadow:0 2px 6px rgba(0,0,0,0.2);display:grid;grid-template-columns:repeat(7,1fr);span{font-size:12px;font-weight:400;color:#000;display:flex;align-items:center;justify-content:center;}"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.tsx

 // import './WeekDays.css';




const WeekDays = ({
  top
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WeekDayWrap, {
    style: {
      top: top
    },
    "data-test-id": "WeekDays-WeekDayWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Sun"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Mon"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Tue"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Wed"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Thu"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Fri"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Sat"
    })]
  });
};

/* harmony default export */ const WeekDays_WeekDays = (WeekDays);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/styles/styles.style.ts

const calenderAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const RangeDatePickerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "stylesstyle__RangeDatePickerStyle",
  componentId: "f6qkoe-0"
})(["display:flex;flex-direction:column;height:100%;box-sizing:border-box;width:100%;position:fixed;left:0;bottom:-100%;z-index:10;background-color:#fff;animation:", " 0.3s ease-in-out;animation-fill-mode:forwards;"], calenderAnim);
const styles_style_ErrorToast = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "stylesstyle__ErrorToast",
  componentId: "f6qkoe-1"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RangeDatePicker/RangeDatePicker.tsx











// import './styles/styles.css';
const RangeDatePicker = ({
  calendarHeader,
  calendarWeekdays = true,
  monthNameType = "short",
  yearType = "numeric",
  calendarFooter,
  onBackPress,
  onSubmitButtonPress,
  range,
  from,
  to,
  showToast,
  toastMessage,
  handleDayClick,
  selected,
  maxEndDate
}) => {
  const {
    0: startDate,
    1: setStartDate
  } = (0,react.useState)(from);
  const {
    0: endDate,
    1: setEndDate
  } = (0,react.useState)(to);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RangeDatePickerStyle, {
    className: "cal__container",
    "data-test-id": "RangeDatePicker-RangeDatePickerStyle",
    children: [calendarHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarHeader_CalendarHeader, {
      checkinDate: startDate,
      checkoutDate: endDate,
      onBackPress: onBackPress,
      "data-test-id": "RangeDatePicker-CalendarHeader"
    }), calendarWeekdays && /*#__PURE__*/(0,jsx_runtime.jsx)(WeekDays_WeekDays, {
      top: calendarHeader ? 49 : 0,
      "data-test-id": "RangeDatePicker-WeekDays"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar_Calendar, {
      handleDayClick: handleDayClick,
      startDate: startDate,
      endDate: endDate,
      monthNameType: monthNameType,
      yearType: yearType,
      selected: selected,
      maxEndDate: maxEndDate,
      "data-test-id": "RangeDatePicker-Calendar"
    }), calendarFooter && /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarFooter_CalendarFooter, {
      checkinDate: selected?.from,
      checkoutDate: selected?.to,
      onSubmitButtonPress: onSubmitButtonPress ? () => onSubmitButtonPress(selected?.from, selected?.to) : () => {},
      "data-test-id": "RangeDatePicker-CalendarFooter"
    }), showToast && /*#__PURE__*/(0,jsx_runtime.jsx)(styles_style_ErrorToast, {
      "data-test-id": "RangeDatePicker-ErrorToast",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.redText */.rS.redText,
        "data-test-id": "RangeDatePicker-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
          value: toastMessage,
          "data-test-id": "RangeDatePicker-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ const RangeDatePicker_RangeDatePicker = (RangeDatePicker);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ReactPortalComp/ReactPortalComp.tsx




const ReactPortalComp = props => {
  const ref = (0,react.useRef)(null);
  const {
    0: mounted,
    1: setMounted
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    ref.current = document.querySelector("#portal");
    setMounted(true);
  }, []);
  (0,react.useEffect)(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return mounted && ref.current ? /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test-id": "ReactPortalComp",
    children: props.children
  }), ref.current) : null;
};

/* harmony default export */ const ReactPortalComp_ReactPortalComp = (ReactPortalComp);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/RichText/RichText.tsx




const RichText = ({
  value
}) => {
  if (typeof value === "string") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(MarkdownText_MarkdownText, {
      value: value,
      "data-test-id": "RichText-MarkdownText"
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
    value: value,
    "data-test-id": "RichText-FormattedText"
  });
};

/* harmony default export */ const RichText_RichText = (RichText);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/SectionDividers/SectionDividers.tsx



const SectionDividers = ({
  small,
  large,
  xs,
  width,
  height,
  borderRadius,
  margin,
  backgroundColor
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividersStyle, {
    backgroundColor: backgroundColor,
    small: small,
    large: large,
    xs: xs,
    width: width,
    height: height,
    borderRadius: borderRadius,
    margin: margin,
    "data-test-id": "SectionDividers-SectionDividersStyle"
  });
};

/* harmony default export */ const SectionDividers_SectionDividers = (SectionDividers);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/Shimmer.style.ts

const shimmer = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{background-position:50% 0;}100%{background-position:-50% 0;}"]);
const ShimmerComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Shimmerstyle__ShimmerComp",
  componentId: "bk32cl-0"
})(["animation:", " 1s linear infinite;background:linear-gradient(to right,#2F2F2F  8%,#393939 18%,#2F2F2F   33%);background-size:800px 104px;position:relative;border-radius:4px;width:", ";height:", ";margin:", ";position:relative;flex-shrink:0;padding:", ";display:flex;align-items:flex-end;}"], shimmer, p => p.width ? p.width : "100%", p => p.height ? p.height : "14px", p => p.margin ? p.margin : "", p => p.padding ? p.padding : "");
const ShimmerVersion2Style = (0,styled_components_browser_esm/* default */.ZP)(ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion2Style",
  componentId: "bk32cl-1"
})(["background:linear-gradient(to right,#f6f6f6 8%,#f9fafb 18%,#f6f6f6 33%);background-size:800px 104px;"]);
const ShimmerVersion3Style = (0,styled_components_browser_esm/* default */.ZP)(ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion3Style",
  componentId: "bk32cl-2"
})(["background:linear-gradient(to right,#cbcbcb 8%,#f9fafb 18%,#cbcbcb 33%);background-size:800px 104px;"]);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/Shimmer.tsx



function Shimmer({
  width,
  height,
  margin,
  padding,
  children
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ShimmerComp, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerComp",
    children: [" ", children]
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/ShimmerVersion2.tsx



function ShimmerVersion2({
  width,
  height,
  margin,
  children,
  padding
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2Style, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerVersion2Style",
    children: children
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Shimmer/ShimmerVersion3.tsx



function ShimmerVersion3({
  width,
  height,
  margin,
  children,
  padding
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion3Style, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerVersion3Style",
    children: children
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Spinner/Spinner.styles.ts

const rotate = (0,styled_components_browser_esm/* keyframes */.F4)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
const SpinnerCont = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Spinnerstyles__SpinnerCont",
  componentId: "sc-18udvui-0"
})(["display:inline-block;height:22px;width:22px;animation:", " 1s linear infinite;border-right-color:transparent;border-radius:50%;margin:-2px auto;"], rotate);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Spinner/Spinner.tsx


function Spinner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Spinner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Spinner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Spinner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const Spinner = ({
  spinnerWidth = 22,
  spinnerColor = "#0189d2",
  thickness = 2,
  customStyle
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpinnerCont, {
    style: Spinner_objectSpread({
      width: spinnerWidth,
      height: spinnerWidth,
      border: `${thickness}px solid ${spinnerColor}`,
      borderRightColor: "transparent"
    }, customStyle),
    "data-test-id": "Spinner-SpinnerCont"
  });
};

/* harmony default export */ const Spinner_Spinner = (Spinner);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Tags/Tags.style.ts


const TagsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Tagsstyle__TagsStyle",
  componentId: "sc-7t089-0"
})(["display:flex;overflow-x:scroll;gap:8px;flex-shrink:0;&::-webkit-scrollbar{display:none;}"]);
const TagItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Tagsstyle__TagItem",
  componentId: "sc-7t089-1"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:0px 10px;cursor:pointer;flex-shrink:0;position:relative;display:flex;align-items:center;justify-content:center;height:33px;", " ", "{position:absolute;top:-5px;left:5px;}"], p => p.isSelected && `
background: #F8FBFF;
border: 1px solid #008CFF;
border-radius: 6px;
`, ImageTagStyle);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Tags/Tags.tsx







const Tags = ({
  data,
  handleClickTab
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TagsStyle, {
    "data-test-id": "Tags-TagsStyle",
    children: data?.map(item => {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TagItem, {
          isSelected: item.isSelected,
          onClick: handleClickTab ? () => handleClickTab(item.id) : () => {},
          "data-test-id": "Tags-TagItem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            color: item.isSelected ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
            fontSize: "xs",
            fontWeight: "black",
            "data-test-id": "Tags-SpanTag",
            children: item.name
          }), item.tagImg && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag_ImageTag, {
            src: item.tagImg,
            width: "30px",
            height: "14px",
            "data-test-id": "Tags-ImageTag"
          })]
        }, item.id)
      });
    })
  });
};

/* harmony default export */ const Tags_Tags = (Tags);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/AnchorTag.tsx





const AnchorTag = ({
  children,
  fontSize = "sm",
  fontWeight = "regular",
  color,
  handleClick,
  hrefProp,
  textAlign,
  margin,
  handleMouseEnter,
  handleMouseLeave,
  textTransform,
  anchorTitle,
  targetProp,
  download = false,
  disableState
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorTagStyle, {
    context: context ? context : undefined,
    textAlign: textAlign,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    onClick: handleClick,
    href: hrefProp,
    margin: margin,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    textTransform: textTransform,
    title: anchorTitle,
    target: targetProp,
    download: download,
    disableState: disableState,
    "data-test-id": "AnchorTag-AnchorTagStyle",
    children: children
  });
};

/* harmony default export */ const TextStyles_AnchorTag = (AnchorTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H2Tag.tsx





const H2Tag = ({
  children,
  margin,
  color
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H2TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H2Tag-H2TagStyle",
    children: children
  });
};

/* harmony default export */ const TextStyles_H2Tag = (H2Tag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H3SmallTag.tsx





const H3SmallTag = ({
  children,
  margin,
  color
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H3TagSmallStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H3SmallTag-H3TagSmallStyle",
    children: children
  });
};

/* harmony default export */ const TextStyles_H3SmallTag = (H3SmallTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H3Tag.tsx





const H3Tag = ({
  children,
  margin,
  color
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H3TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H3Tag-H3TagStyle",
    children: children
  });
};

/* harmony default export */ const TextStyles_H3Tag = (H3Tag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H4Tag.tsx





const H4Tag = ({
  children,
  margin,
  color
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H4TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H4Tag-H4TagStyle",
    children: children
  });
};

/* harmony default export */ const TextStyles_H4Tag = (H4Tag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H5Tag.tsx





const H5Tag = ({
  children,
  margin,
  color
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(H5TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H5Tag-H5TagStyle",
    children: children
  });
};

/* harmony default export */ const TextStyles_H5Tag = (H5Tag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/H6Tag.tsx





const H6Tag = ({
  children,
  margin,
  color
}) => {
  const context = usePartnerContext();
  return /*#__PURE__*/_jsx(H6TagStyle, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H6Tag-H6TagStyle",
    children: children
  });
};

/* harmony default export */ const TextStyles_H6Tag = ((/* unused pure expression or super */ null && (H6Tag)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/ParaTag.tsx





const ParaTag = ({
  children,
  fontSize = "sm",
  fontWeight = "regular",
  color = "#000000",
  margin,
  textAlign,
  lineHeight,
  dangerousText,
  textTransform
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "ParaTag-ParaTagStyle"
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ParaTagStyle, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "ParaTag-ParaTagStyle",
    children: children
  });
};

/* harmony default export */ const TextStyles_ParaTag = (ParaTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TextStyles/SpanTag.tsx





const SpanTag_SpanTag = ({
  fontSize = "sm",
  fontWeight = "regular",
  color = "black",
  margin,
  children,
  textTransform,
  dangerousText,
  style
}) => {
  if (dangerousText && typeof dangerousText !== "string") {
    dangerousText = String(dangerousText);
  }

  const context = (0,hooks/* usePartnerContext */.X)();
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTagStyle, {
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    context: context ? context : undefined,
    "data-test-id": "SpanTag-SpanTagStyle"
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTagStyle, {
    style: style,
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "SpanTag-SpanTagStyle",
    children: children
  });
};

/* harmony default export */ const TextStyles_SpanTag = (SpanTag_SpanTag);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/TMFloatingInput/TMFloatingInput.tsx








const TMFloatingInput = ({
  placeholderTxt,
  labelTxt,
  disableState,
  inputWidth,
  margin,
  errorState,
  inputValue,
  handleChange,
  verifiedTag,
  maxLength,
  onFocus,
  onBlur,
  type = "text",
  inputMode,
  flex,
  fieldType = "text",
  showEdit = false,
  handleEditClick,
  handleDropdownPress
}) => {
  const {
    0: isFocus,
    1: setIsFocus
  } = (0,react.useState)(false);

  const inputFocusHandler = event => {
    if (fieldType === "select") {
      event.preventDefault();
      event.currentTarget.blur();
    }

    !(fieldType === "select") && setIsFocus(true);
    onFocus && onFocus();
  };

  const inputBlurHandler = () => {
    !(fieldType === "select") && setIsFocus(false);
    onBlur && onBlur();
  };

  const handleClick = () => {
    if (fieldType === "select" && handleDropdownPress) {
      handleDropdownPress();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TMInputWrap, {
    disableState: disableState,
    margin: margin,
    inputWidth: inputWidth,
    flex: flex,
    placeholder: placeholderTxt,
    clickable: fieldType === "select",
    onClick: handleClick,
    "data-test-id": "TMFloatingInput-TMInputWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputWpr, {
      "data-test-id": "TMFloatingInput-InputWpr",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TMInputStyle, {
        id: labelTxt,
        isActive: isFocus,
        inputMode: inputMode,
        onChange: fieldType === "select" ? () => {} : handleChange,
        value: inputValue,
        errorState: errorState,
        onBlur: inputBlurHandler,
        verifiedTag: verifiedTag,
        disableState: disableState,
        onFocus: inputFocusHandler,
        placeholder: placeholderTxt,
        spellCheck: "false",
        maxLength: maxLength,
        type: type,
        required: true,
        clickable: fieldType === "select",
        "data-test-id": "TMFloatingInput-TMInputStyle"
      }), labelTxt && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        htmlFor: fieldType === "select" ? "" : labelTxt,
        className: "labelText",
        "data-test-id": "TMFloatingInput-label",
        children: labelTxt
      }), fieldType === "text" && verifiedTag && /*#__PURE__*/(0,jsx_runtime.jsx)(VerifiedContainer, {
        "data-test-id": "TMFloatingInput-VerifiedContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "xs",
          fontWeight: "bold",
          color: Global/* theme.darkGreen */.rS.darkGreen,
          "data-test-id": "TMFloatingInput-ParaTag",
          children: verifiedTag
        })
      }), fieldType === "text" && showEdit && /*#__PURE__*/(0,jsx_runtime.jsx)(IconContainer, {
        onClick: handleEditClick,
        "data-test-id": "TMFloatingInput-IconContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* EditIcon */.dY, {
          "data-test-id": "TMFloatingInput-EditIcon"
        })
      }), fieldType === "select" && /*#__PURE__*/(0,jsx_runtime.jsx)(IconContainer, {
        "data-test-id": "TMFloatingInput-IconContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* DownArrow */.pL, {
          "data-test-id": "TMFloatingInput-DownArrow"
        })
      })]
    }), errorState && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      margin: "4px 0 0",
      color: Global/* theme.redText2 */.rS.redText2,
      fontSize: "xs",
      dangerousText: errorState,
      "data-test-id": "TMFloatingInput-ParaTag"
    })]
  });
};

/* harmony default export */ const TMFloatingInput_TMFloatingInput = (TMFloatingInput);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Toast/Toast.tsx







const Toast = ({
  toastCtaTxt,
  planSelectedTxt,
  handleClickCta,
  handleClose,
  autoCloseDuration = 3000,
  toastCloseIcon,
  toastIcon,
  isDisable,
  showToast,
  width,
  height
}) => {
  const {
    0: visible,
    1: setVisible
  } = useState(true);
  useEffect(() => {
    let timer;

    if (autoCloseDuration) {
      timer = setTimeout(() => {
        if (visible) {
          setVisible(false);
        }
      }, autoCloseDuration);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [autoCloseDuration, visible]);
  return visible ? /*#__PURE__*/_jsxs(ToastStyle, {
    "data-test-id": "Toast-ToastStyle",
    children: [/*#__PURE__*/_jsxs(FlexComp, {
      gap: "16px",
      alignItems: "center",
      "data-test-id": "Toast-FlexComp",
      children: [toastIcon && /*#__PURE__*/_jsx(ToastIcon, {
        "data-test-id": "Toast-ToastIcon",
        children: /*#__PURE__*/_jsx(ImageComponent, {
          width: width ? width : "50px",
          height: height ? height : "50px",
          src: toastIcon,
          "data-test-id": "Toast-ImageComponent"
        })
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "md",
        color: theme.whiteText,
        "data-test-id": "Toast-SpanTag",
        children: planSelectedTxt && /*#__PURE__*/_jsx(FormattedText, {
          value: planSelectedTxt,
          "data-test-id": "Toast-FormattedText"
        })
      })]
    }), toastCtaTxt && /*#__PURE__*/_jsx(LandingButtonWhite, {
      customTitle: toastCtaTxt,
      onClick: handleClickCta,
      disableState: isDisable,
      "data-test-id": "Toast-LandingButtonWhite"
    }), toastCloseIcon && /*#__PURE__*/_jsx(CloseIconWrap, {
      onClick: handleClose,
      "data-test-id": "Toast-CloseIconWrap",
      children: /*#__PURE__*/_jsx(ImageComponent, {
        width: "28px",
        height: "28px",
        src: toastCloseIcon,
        "data-test-id": "Toast-ImageComponent"
      })
    })]
  }) : null;
};

/* harmony default export */ const Toast_Toast = ((/* unused pure expression or super */ null && (Toast)));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Toast/WebToast.style.tsx



const WebToastStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WebToaststyle__WebToastStyle",
  componentId: "qqkgrl-0"
})(["position:", ";top:", ";left:", ";width:", ";height:", ";background:", ";display:flex;align-items:", ";z-index:200;justify-content:", ";box-shadow:0px 3px 30px rgba(0,0,0,0.16);", " padding:12px 16px 12px 16px;border-radius:6px;bottom:", ";right:", ";picture{height:19px;width:19px;padding:2px;}", "{flex-shrink:0;}@media ", "{width:calc(100% - 32px);padding:8px 16px;right:16px;left:16px;}"], p => p.position ? `${p.position}` : `absolute`, p => `${p.top}`, p => `${p.left}`, p => `${p.width}`, p => `${p.height}`, p => p.background ? `${p.background}` : `#4a4a4a`, p => p.alignItems ? `${p.alignItems}` : `center`, p => p.justifyContent ? `${p.justifyContent}` : `space-between`, p => p.margin && `margin: ${p.margin};`, p => `${p.bottom}`, p => `${p.right}`, SpanTagStyle, src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/Toast/WebToast.tsx






const TOAST_BG_COLOR = {
  error: "#FCDADB",
  success: "#B8F5E0",
  default: "#4A4A4A",
  warning: "#FFEDD1"
};

const WebToast = ({
  iconUrl,
  position,
  toastTxt,
  fontSize,
  fontWeight,
  toastTxtMargin,
  top,
  left,
  margin,
  width,
  bottom,
  right,
  height,
  type = "default",
  color
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WebToastStyle, {
    top: top,
    bottom: bottom,
    right: right,
    left: left,
    width: width,
    height: height,
    margin: margin,
    position: position,
    justifyContent: type === "success" || type === "warning" ? "center" : "space-between",
    background: TOAST_BG_COLOR[type],
    "data-test-id": "WebToast-WebToastStyle",
    children: [iconUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      height: "15px",
      width: "15px",
      src: iconUrl,
      "data-test-id": "WebToast-ImageComponent"
    }), toastTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      gap: "10px",
      alignItems: "center",
      "data-test-id": "WebToast-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FormattedText_FormattedText, {
        value: toastTxt,
        baseStyle: {
          fontSize: fontSize ? fontSize : "12px",
          fontWeight: fontWeight ? fontWeight : "normal",
          color: color ? color : "#FFFFFF",
          margin: toastTxtMargin ? toastTxtMargin : "10px"
        },
        "data-test-id": "WebToast-FormattedText"
      })
    })]
  });
};

/* harmony default export */ const Toast_WebToast = (WebToast);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/ToolTipComp/ToolTipComp.style.ts

const ToolTipCompWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ToolTipCompstyle__ToolTipCompWrapper",
  componentId: "sc-1jxr57r-0"
})(["position:absolute;background:#1a7971;border:4px solid #1a7971;left:", ";right:", ";top:", ";bottom:", ";width:", ";font-size:14px;line-height:20px;padding:8px;border-radius:4px;gap:20px;z-index:1;color:#ffffff;&:after,&:before{border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(0,0,0,0);border-width:13px;}&:before{border-color:rgba(0,0,0,0);border-width:13px;}", " ", " ", " ", ""], props => props.left, props => props.right, props => props.top, props => props.bottom, props => props.width, props => props.toolTipArrow == "top" && `
&:after, &:before {
	bottom: 100%;
	left: 50%;
}

&:after {
	border-bottom-color: #1A7971;
	margin-top: -30px;
}
&:before {
	border-bottom-color: #1A7971;
	margin-top: -36px;
}

`, props => props.toolTipArrow == "bottom" && `
&:after, &:before {
	top: 100%;
	left: 50%;
}

&:after {
	border-top-color: #1A7971;;
	margin-left: -34px;
}
&:before {
	border-top-color: #1A7971;
	margin-left: -36px;
}

`, props => props.toolTipArrow == "right" && `
&:after, &:before {
	left: 100%;
	top: 50%;
}

&:after {
	border-left-color: #1A7971;
	margin-top: -30px;
}
&:before {
	border-left-color: #1A7971;
	margin-top: -36px;
}

`, props => props.toolTipArrow == "left" && `
&:after, &:before {
	right: 100%;
	top: 50%;
}

&:after {
	border-right-color: #1A7971;
	margin-top: -17px;
}
&:before {
	border-right-color: #1A7971;
	margin-top: -19px;
}

`);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx
















































/***/ }),

/***/ 81594:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rS": () => (/* binding */ theme)
/* harmony export */ });
/* unused harmony exports fontWeight, fontSize, lineHeight */
const theme = {
  blackText: "#000",
  blackText3: "#022135",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText3: " #009997",
  greenText4: "#38A97A",
  greenText5: "#2B825E",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "rgba(255, 255, 255, 0.8)",
  redText: "#960D11",
  redText2: "#EB2026",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  lightBlack: "rgba(0, 0, 0, 0.3)",
  gray97: "#f7f7f7",
  lightGrey: "#d2d2d2",
  blueLight: "#F9FCFF",
  smokeWhite: "#F6F6F6",
  lightSilver: "#D8D8D8",
  snowWhite: "#FFFAFA",
  gainsBoro: "#e2e2e2",
  darkGreen: "#1E5C43",
  lightGreen: "#249054",
  persianGreen: "#009997",
  lightRed: "#fcdadb",
  blackText2: "#1E1E1E",
  whiteText2: "#f5f5f5",
  greenText2: "#E4FBF4",
  redText3: "#A73232",
  redText4: "#C53B3B",
  yellowText2: "#FFEDD1",
  yellowText3: "#FFDA9E",
  yellowText4: "#FFC76B",
  darkYellowText: "#B48B28",
  prussianBlue: "#005499",
  purpleTxt: "#A05ACD",
  berryTxt: "#AF0067",
  greenNeonText2: "#33BA9E",
  greenNeonText3: "#5EE8BA",
  blueText2: "#F6FAFF",
  darkGreen2: "#227055",
  greenBg: "rgba(43, 130, 94, 0.5)"
};
const fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900"
};
const fontSize = {
  font10: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px"
};
const lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px"
};

/***/ }),

/***/ 51046:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ol": () => (/* reexport */ ArrowRight),
  "a": () => (/* reexport */ BlueChev),
  "g8": () => (/* reexport */ ChevronUpIcon),
  "pL": () => (/* reexport */ DownArrow),
  "dY": () => (/* reexport */ EditIcon),
  "rj": () => (/* reexport */ StarEmpty),
  "Um": () => (/* reexport */ StarFull)
});

// UNUSED EXPORTS: MMTIcon

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/ArrowRight.tsx


const ArrowRight = ({
  width,
  height
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: `${width}px`,
    height: `${height}px`,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "ArrowRight",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 6.86518L21 6.86182L1 6.86518Z",
      fill: "#008CFF"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1 6.86518L21 6.86182",
      stroke: "#008CFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.8595 13L20.2086 7.65621C20.5731 7.29196 20.5731 6.70132 20.2075 6.33707L14.8595 1",
      stroke: "#008CFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/BlueChev.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const BlueChev = props => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "BlueChev",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00005 9.5L12.25 4.25L13.5 5.5L7.00005 12.0028L0.5 5.5L1.75 4.25L7.00005 9.5Z",
    fill: "#008CFF"
  })
}));


// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/ChevronUpIcon.tsx


const _excluded = ["color", "cursor"];

function ChevronUpIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ChevronUpIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChevronUpIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChevronUpIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const ChevronUpIcon = _ref => {
  let {
    color = "#008cff",
    cursor = "pointer"
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ChevronUpIcon_objectSpread(ChevronUpIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "ChevronUpIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.8583 10.6059C11.9364 10.5278 12.063 10.5278 12.1411 10.6059L16.2423 14.7071C16.6329 15.0976 17.266 15.0976 17.6566 14.7071V14.7071C18.0471 14.3166 18.0471 13.6834 17.6566 13.2929L12.7068 8.34315C12.3163 7.95262 11.6831 7.95262 11.2926 8.34315L6.34285 13.2929C5.95232 13.6834 5.95232 14.3166 6.34285 14.7071V14.7071C6.73337 15.0976 7.36654 15.0976 7.75706 14.7071L11.8583 10.6059Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/DownArrow.tsx


function DownArrow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DownArrow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DownArrow_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DownArrow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const DownArrow = props => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", DownArrow_objectSpread(DownArrow_objectSpread({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "DownArrow",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M11.8583 13.3941C11.9364 13.4722 12.063 13.4722 12.1411 13.3941L16.2423 9.29289C16.6329 8.90237 17.266 8.90237 17.6566 9.29289C18.0471 9.68342 18.0471 10.3166 17.6566 10.7071L12.7068 15.6569C12.3163 16.0474 11.6831 16.0474 11.2926 15.6569L6.34285 10.7071C5.95232 10.3166 5.95232 9.68342 6.34285 9.29289C6.73337 8.90237 7.36654 8.90237 7.75706 9.29289L11.8583 13.3941Z",
    fill: "#008CFF"
  })
}));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/EditIcon.tsx


const EditIcon_excluded = ["size", "color", "cursor"];

function EditIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EditIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EditIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EditIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



const EditIcon = _ref => {
  let {
    size = 24,
    color = "#008CFF",
    cursor = "pointer"
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, EditIcon_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", EditIcon_objectSpread(EditIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: size,
    height: size,
    viewBox: `0 0 24 24`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "EditIcon",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.378 5.45329C15.9045 4.9268 16.7581 4.9268 17.2846 5.45328L19.0567 7.2254C19.5832 7.75188 19.5832 8.60548 19.0567 9.13196L18.3203 9.86834C18.1097 10.0789 17.7683 10.0789 17.5577 9.86834L14.6416 6.95229C14.431 6.74169 14.431 6.40025 14.6416 6.18966L15.378 5.45329Z",
      fill: color
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1781 7.64303C13.3887 7.43244 13.7302 7.43244 13.9408 7.64303L16.8568 10.5591C17.0674 10.7697 17.0674 11.1111 16.8568 11.3217L10.3652 17.8134C10.2926 17.8859 10.1997 17.9347 10.0988 17.9532L6.59734 18.5945C6.25606 18.657 5.95467 18.365 6.00634 18.0219L6.55028 14.4106C6.56638 14.3038 6.61629 14.2049 6.69271 14.1285L13.1781 7.64303Z",
      fill: color
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/MMTIcon.tsx


function MMTIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MMTIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MMTIcon_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MMTIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



const MMTIcon = ({
  props
}) => /*#__PURE__*/_jsxs("svg", MMTIcon_objectSpread(MMTIcon_objectSpread({
  width: 86,
  height: 28,
  viewBox: "0 0 86 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  "data-test-id": "MMTIcon",
  children: [/*#__PURE__*/_jsx("rect", {
    x: 37.2598,
    y: 4.68359,
    width: 23.8612,
    height: 22.4215,
    rx: 6,
    fill: "white",
    "data-test-id": "MMTIcon-rect"
  }), /*#__PURE__*/_jsx("mask", {
    id: "mask0_1734_41229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 0,
    width: 28,
    height: 28,
    "data-test-id": "MMTIcon-mask",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M62.6091 27.8695V0.365234H35.2988V27.8695H62.6091Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("g", {
    mask: "url(#mask0_1734_41229)",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M60.3565 9.77361C59.0587 12.0098 56.74 16.8177 56.74 16.8177C56.74 16.8177 55.5721 19.4131 55.0783 22.0653C54.8587 23.2447 55.2827 24.6147 55.2827 24.6147C55.5999 25.9675 54.0972 25.5958 54.0972 25.5958C52.9995 25.2332 53.03 23.7589 53.03 23.7589C53.03 21.5828 53.9928 19.4794 54.557 18.0716C52.5746 18.8576 51.6475 16.9195 52.2116 14.9624L49.9456 18.0365C49.2164 18.8983 48.498 18.7296 48.498 18.7296C48.4615 18.7296 47.5896 18.6228 47.6337 17.4529C47.6551 16.8864 47.8134 14.5232 47.9949 13.6455C48.0133 13.5537 47.9589 13.4623 47.8859 13.5722C46.9409 15.2542 45.3924 17.0873 45.0845 17.5955C44.6851 18.2544 44.2844 18.5275 44.2844 18.5275C43.9624 18.7885 43.403 18.5912 43.403 18.5912C42.8298 18.3774 42.947 17.7255 42.947 17.7255L43.4898 13.7871C43.4898 13.7331 43.4719 13.7143 43.4172 13.7143C43.2538 13.7143 41.7173 15.8555 40.8695 17.3493L40.3144 18.252C40.3144 18.252 39.8351 19.0085 39.0948 18.5534C38.5159 18.1973 38.6979 17.5318 38.6979 17.5318L40.2856 10.8112C40.2856 10.7929 40.2856 10.6832 40.1943 10.6832C39.7034 10.6832 39.5637 11.9704 38.8925 11.9952C38.5548 12.0077 38.3808 11.8623 38.3808 11.8623C37.923 11.5974 38.1403 10.9105 38.1403 10.9105C38.1403 10.9105 38.8655 8.97975 39.8266 8.4945C39.8266 8.4945 40.3811 8.14464 40.843 8.20718C41.3051 8.26972 42.0443 8.38121 41.6563 10.5005L41.1715 13.2572C41.1715 13.2572 41.1231 13.4983 41.1982 13.5368C41.1982 13.5368 41.3179 13.6566 41.5593 13.333L44.6338 9.10418C45.2961 8.12532 46.0768 8.61909 46.0768 8.61909C46.5968 8.84109 46.4184 9.48236 46.4184 9.48236C46.4184 9.48236 44.903 14.1629 44.903 14.6016C44.903 14.748 45.0306 14.7842 45.1029 14.6751C45.7389 13.7056 47.0844 11.6023 48.2122 10.1944C48.7206 9.57273 49.0121 9.29818 49.5753 9.35319C50.1205 9.40804 50.3752 9.75544 50.3752 10.3041C50.3752 10.3956 50.3568 10.5053 50.3393 10.6151C50.3393 10.6151 49.3391 14.0715 49.2659 15.9184C49.2659 15.9184 49.2504 16.1839 49.3204 16.2376C49.4552 16.3411 49.6215 16.1081 49.6215 16.1081C50.1811 15.488 51.9707 12.6424 52.3752 11.8951L53.6699 9.24514C53.6699 9.24514 54.2194 8.03953 54.9533 8.22699C54.9533 8.22699 56.1209 8.34552 55.5568 9.62381C55.4643 9.83304 54.5754 11.2864 53.8114 14.2863C53.6843 14.7429 53.5204 16.0783 54.3382 16.0783C54.702 16.0783 55.175 15.7851 55.6658 14.8889L58.8834 9.07389C59.156 8.78084 59.3718 8.61909 59.7532 8.61909C60.9445 8.61909 60.3565 9.77361 60.3565 9.77361ZM62.6087 6.59235C62.6087 3.15774 59.8562 0.365234 56.4625 0.365234H41.4468C38.052 0.365234 35.2998 3.15774 35.2998 6.59235L35.3031 21.6389C35.3031 25.0725 38.0548 27.8696 41.4493 27.8696H56.4648C59.8593 27.8696 62.61 25.0733 62.61 21.6389L62.6087 6.59235Z",
      fill: "#EB2226"
    })
  }), /*#__PURE__*/_jsx("mask", {
    id: "mask1_1734_41229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 11,
    height: 8,
    "data-test-id": "MMTIcon-mask",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 17.5647H10.3158V10.5566H0L0 17.5647Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("g", {
    mask: "url(#mask1_1734_41229)",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.00933 17.5647H4.30673V13.7095C4.30673 13.1602 4.21981 12.7499 4.0468 12.4795C3.87363 12.209 3.58099 12.0735 3.16775 12.0735C2.86697 12.0735 2.59159 12.1481 2.34159 12.2978C2.09078 12.4479 1.87822 12.6609 1.70277 12.9371V17.5647H0V10.5634H0.969709L1.60983 11.505C1.74736 11.3792 1.95602 11.2205 2.12496 11.1107C2.29407 11.0008 2.47245 10.9042 2.66043 10.822C2.84793 10.74 3.04552 10.6758 3.25206 10.6279C3.4586 10.5802 3.67051 10.5566 3.88763 10.5566C4.13746 10.5566 4.358 10.5832 4.54728 10.6372C4.73755 10.6904 4.90535 10.7685 5.05134 10.8718C5.19734 10.9744 5.3251 11.0981 5.4335 11.2429C5.54206 11.3886 5.6376 11.5527 5.72109 11.7359C5.85471 11.6016 6.00592 11.4646 6.17518 11.3237C6.34413 11.1829 6.53097 11.0558 6.73556 10.9419C6.94014 10.8281 7.16312 10.7354 7.40514 10.6639C7.64749 10.5923 7.90985 10.5566 8.19419 10.5566C8.57765 10.5566 8.90381 10.6354 9.17367 10.7924C9.44287 10.9499 9.66178 11.1676 9.83104 11.4461C9.99999 11.7246 10.1224 12.0561 10.1999 12.4402C10.277 12.8246 10.3159 13.2436 10.3159 13.6967V17.5647H8.61313V13.7095C8.61313 13.1602 8.52768 12.7499 8.35646 12.4795C8.18556 12.209 7.89927 12.0735 7.49938 12.0735C7.19877 12.0735 6.92305 12.1439 6.67241 12.2843C6.42225 12.425 6.20139 12.6419 6.00933 12.9371V17.5647Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9324 14.3823H14.4049C13.9962 14.3823 13.6976 14.4792 13.5094 14.6372C13.3219 14.7945 13.228 15.0149 13.228 15.2966C13.228 15.5656 13.3074 15.7729 13.4661 15.9188C13.6246 16.0638 13.8667 16.1375 14.1917 16.1375C14.3883 16.1375 14.5747 16.111 14.7524 16.0586C14.93 16.0055 15.0935 15.9351 15.2438 15.8456C15.3937 15.756 15.5271 15.6503 15.6443 15.5263C15.7607 15.4029 15.8569 15.2724 15.9324 15.1354V14.3823ZM15.9317 16.7939C15.735 17.0092 15.4264 17.2102 15.0777 17.3553C14.7291 17.4994 14.3128 17.5722 13.8291 17.5722C13.491 17.5722 13.1863 17.5179 12.9145 17.4085C12.6434 17.3001 12.4114 17.1472 12.2173 16.9501C12.0233 16.753 11.8739 16.5207 11.7692 16.2517C11.6652 15.9824 11.6133 15.6887 11.6133 15.3691C11.6133 14.0646 12.6159 13.2355 14.2224 13.2355H15.919V12.8485C15.919 12.6095 15.7994 12.4214 15.5593 12.2852C15.3198 12.1489 14.9514 12.08 14.4547 12.08C13.9915 12.08 13.5626 12.1291 13.1686 12.2269C12.7746 12.324 12.556 12.4063 12.2179 12.5464L12.0075 11.0851C12.1323 11.0298 12.285 10.9715 12.4645 10.9099C12.6434 10.8482 12.8444 10.7914 13.0652 10.7382C13.2864 10.6861 13.5263 10.6421 13.7851 10.608C14.0434 10.5733 14.3152 10.5566 14.5987 10.5566C15.5836 10.5566 16.3232 10.7989 16.8179 11.2847C17.3119 11.7695 17.5593 12.4592 17.5593 13.3532V17.5647H16.3461L15.9317 16.7939Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6119 10.4593L22.8357 13.9617L25.9934 17.5649H23.8528L20.9329 14.01V17.5649H19.2305V7.95508H20.9329V14.01L23.5336 10.4593H25.6119Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3989 12.0668C29.1738 12.0668 28.9692 12.0946 28.7851 12.1509C28.6017 12.2071 28.441 12.2873 28.3035 12.3899C28.166 12.4932 28.0528 12.6177 27.9651 12.7635C27.8777 12.9105 27.8173 13.0715 27.7838 13.2475H30.8074C30.8074 13.0898 30.779 12.939 30.7224 12.7948C30.6664 12.6502 30.5798 12.5248 30.4626 12.4184C30.3461 12.311 30.1988 12.2259 30.0219 12.1622C29.8442 12.0987 29.637 12.0668 29.3989 12.0668ZM29.7177 16.0621C30.0182 16.0621 30.2906 16.0375 30.5346 15.9899C30.7787 15.9423 31.0011 15.8787 31.2011 15.8011C31.4018 15.723 31.5834 15.6323 31.7458 15.53C31.9084 15.4269 31.8518 15.4758 31.9852 15.3699L32.3137 16.8826C32.0129 17.0753 31.5881 17.2459 31.1602 17.3759C30.7327 17.5064 30.246 17.5722 29.6992 17.5722C29.1025 17.5722 28.5742 17.4879 28.1157 17.3204C27.6564 17.1524 27.269 16.917 26.9538 16.6123C26.6393 16.3077 26.3997 15.9423 26.2373 15.5141C26.0749 15.086 25.9932 14.6116 25.9932 14.0911C25.9932 13.6101 26.0675 13.1555 26.2155 12.7274C26.3636 12.2991 26.5807 11.9245 26.8664 11.6023C27.1523 11.2799 27.5058 11.0254 27.9274 10.8377C28.3492 10.6506 28.8354 10.5566 29.386 10.5566C29.9413 10.5566 30.4195 10.6457 30.8228 10.8237C31.2248 11.0018 31.557 11.2388 31.8174 11.5347C32.0787 11.8313 32.2714 12.1714 32.3972 12.5556C32.5223 12.9397 32.5682 13.338 32.5682 13.7504C32.5682 13.8616 32.5617 13.9894 32.5492 14.1329C32.5367 14.2764 32.5204 14.3982 32.4992 14.497H27.7526C27.7773 14.7391 27.84 14.9568 27.9401 15.1487C28.04 15.3413 28.1748 15.5048 28.3437 15.6397C28.513 15.7746 28.713 15.8787 28.9444 15.9519C29.1761 16.0256 29.434 16.0621 29.7177 16.0621Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2822 11.5566L66.5825 8.80273H67.0869V10.5633H69.0522V12.0875H67.0869V14.9568C67.0869 15.1562 67.1106 15.3227 67.1588 15.456C67.2062 15.5883 67.2727 15.694 67.3564 15.7743C67.4392 15.8537 67.5353 15.9097 67.6435 15.9436C67.7522 15.9766 67.8674 15.993 67.9881 15.993C68.2133 15.993 68.4127 15.9714 68.5854 15.9277C68.759 15.8844 68.9128 15.8294 69.0461 15.7641V17.29C68.8621 17.3821 68.6692 17.4519 68.467 17.4998C68.2646 17.5485 68.0173 17.5722 67.725 17.5722C67.3121 17.5722 66.9571 17.5232 66.6613 17.4245C66.365 17.3258 66.1227 17.1837 65.9355 16.9959C65.7466 16.8076 65.608 16.5793 65.5187 16.3113C65.4292 16.0433 65.3836 15.7394 65.3836 15.3995V12.0875H64.2822V11.5566Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.955 12.006C72.1847 11.5864 72.5958 11.1824 72.936 10.9319C73.2757 10.6817 73.6842 10.5566 74.1593 10.5566C74.3219 10.5566 74.4552 10.5648 74.5572 10.581C74.6594 10.5972 74.7374 10.613 74.7918 10.6269C74.7918 10.6269 74.7374 11.0229 74.4788 12.2323C74.374 12.209 74.2491 12.1972 74.1028 12.1972C73.7815 12.1972 73.4952 12.2527 73.2423 12.3646C72.9899 12.4764 72.776 12.6375 72.6012 12.8469C72.4262 13.0568 72.2913 13.3144 72.1974 13.618C72.1028 13.9218 72.0563 14.2658 72.0563 14.6495V17.5647H70.3535V10.5632H71.4445L71.955 12.006Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("mask", {
    id: "mask2_1734_41229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 10,
    width: 7,
    height: 11,
    "data-test-id": "MMTIcon-mask",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M85.9243 20.3934V10.5566L79.2148 10.5566V20.3934H85.9243Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("g", {
    mask: "url(#mask2_1734_41229)",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M82.5325 12.0876C82.316 12.0876 82.1192 12.1199 81.9443 12.1847C81.7694 12.2491 81.6147 12.333 81.481 12.4368C81.3473 12.5395 81.2328 12.6575 81.137 12.789C81.0409 12.92 80.963 13.0549 80.9055 13.1927V15.1809C80.9716 15.3009 81.0589 15.4147 81.1645 15.5222C81.2711 15.6293 81.3907 15.7236 81.5248 15.8053C81.6584 15.8868 81.807 15.952 81.9722 16.0019C82.1371 16.0509 82.3132 16.0754 82.5014 16.0754C82.7888 16.0754 83.0386 16.0283 83.2491 15.9335C83.4598 15.8397 83.6348 15.7074 83.7751 15.5381C83.9149 15.3679 84.0188 15.1642 84.0848 14.9257C84.1516 14.6876 84.1848 14.4244 84.1848 14.1364C84.1848 13.836 84.1454 13.5599 84.0656 13.3085C83.9867 13.057 83.8746 12.8414 83.7281 12.661C83.5813 12.4807 83.4078 12.3396 83.2053 12.2391C83.0023 12.1379 82.7787 12.0876 82.5325 12.0876ZM84.2999 10.8505C84.6698 11.0471 84.9753 11.3099 85.2169 11.6388C85.4592 11.9677 85.6376 12.3469 85.7525 12.7778C85.8669 13.2072 85.9244 13.6545 85.9244 14.1171C85.9244 14.5896 85.8638 15.0336 85.7429 15.4511C85.6218 15.8683 85.4395 16.2342 85.1954 16.5498C84.9512 16.8646 84.6475 17.1141 84.2841 17.2975C83.9216 17.481 83.496 17.5722 83.0074 17.5722C82.5318 17.5722 82.1303 17.5026 81.8025 17.3623C81.4751 17.2235 81.188 17.0185 80.9422 16.7482L80.9171 16.7628V20.3934H79.2148V10.5634H80.2331L80.8834 11.4162C81.1302 11.1626 81.4808 10.9162 81.8214 10.7724C82.1619 10.6285 82.5458 10.5566 82.9763 10.5566C83.4895 10.5566 83.9314 10.6554 84.2999 10.8505Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5459 7.68164C76.0555 7.68164 75.6592 8.08111 75.6592 8.57406C75.6592 9.06717 76.0555 9.46697 76.5459 9.46697C77.0359 9.46697 77.4331 9.06717 77.4331 8.57406C77.4331 8.08111 77.0359 7.68164 76.5459 7.68164ZM75.695 17.5648H77.3974V10.5635H75.695V17.5648Z",
    fill: "white"
  })]
}));
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/StarEmpty.tsx


const StarEmpty_excluded = ["width", "height"];

function StarEmpty_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarEmpty_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarEmpty_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarEmpty_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const StarEmpty = _ref => {
  let {
    width = 26,
    height = 25
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StarEmpty_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", StarEmpty_objectSpread(StarEmpty_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "StarEmpty",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0675 19.9704L6.05072 23.7389L7.3908 15.7571L1.71415 10.1044L9.55909 8.93983L13.0675 1.67773L16.5758 8.93983L24.4208 10.1044L18.7441 15.7571L20.0842 23.7389L13.0675 19.9704Z",
      fill: "#E2B634",
      fillOpacity: 0.1,
      stroke: "#E2B634",
      strokeOpacity: 0.4
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/StarFull.tsx


const StarFull_excluded = ["width", "height"];

function StarFull_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarFull_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarFull_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarFull_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const StarFull = _ref => {
  let {
    width = 24,
    height = 23
  } = _ref,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StarFull_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", StarFull_objectSpread(StarFull_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "StarFull",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9415 18.9704L4.92475 22.7389L6.26482 14.7571L0.588172 9.10436L8.43311 7.93983L11.9415 0.677734L15.4498 7.93983L23.2948 9.10436L17.6181 14.7571L18.9582 22.7389L11.9415 18.9704Z",
      fill: "#E2B634"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/icons/index.tsx









/***/ }),

/***/ 86570:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(65525);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39148:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 39824:
/***/ (() => {

/* (ignored) */

/***/ })

}]);